<template>
  <div class="post_main">
    <!-- 标题 -->
    <div class="title">
      <h2>{{ mode == 'edit' ? '修改' : '刊登' }}{{ propertyInfo.rentalType == 1 ? '售' : '租' }}盤</h2>
      <a
        class="charges"
        href="/helpcenter/asidelist?categoryID=14"
        target="view_window"
      >收費標準</a>
      <p>
        <template v-if="isUsedCoin">
          <svg
            class="icon iconjinbi"
            aria-hidden="true"
          >
            <use xlink:href="#iconjinbi" />
          </svg>
          <span v-if="accountType && (userInfo.roleID == 1 || userInfo.roleID == 2)">
            公司賬戶持有House730金幣：<i>{{ remainderStrPropertyCoin }}</i></span>
          <span
            v-else
          >個人持有House730金幣：<i>{{ remainderStrPropertyCoin }}</i></span>
          <span
            v-if="isUsedDiamond"
            class="line"
          >/</span>
        </template>
        <template v-if="isUsedDiamond">
          <svg
            class="icon iconzuanshi"
            aria-hidden="true"
          >
            <use xlink:href="#iconzuanshi" />
          </svg>
          <span v-if="accountType && (userInfo.roleID == 1 || userInfo.roleID == 2)">
            公司賬戶持有House730鑽石：<i>{{ remainderStrDiamond }}</i></span>
          <span
            v-else
          >個人持有House730鑽石：<i>{{ remainderStrDiamond }}</i></span>
        </template>
      </p>
      <p><i class="red">*</i>必填</p>
    </div>
    <!-- 楼盘类型 -->
    <el-form
      ref="propertyInfo"
      :model="propertyInfo"
      label-width="155px"
      class="demo-ruleForm"
      :rules="rules"
      @submit.native.prevent
    >
      <!-- 遮罩层 续期||立即付款 无法修改楼盘信息 -->
      <div
        v-if="mode === '1'"
        class="disable"
      />
      <div class="type">
        <h3>樓盤類型</h3>
        <div class="content">
          <el-row
            :gutter="20"
            class="cate"
          >
            <el-form-item
              label="樓盤類型"
              prop="propertyCategory"
            >
              <el-radio-group
                class="onlyChoose"
                :disabled="(searchRes && conditions) || (fromZy && showZyAdress)"
                :value="propertyInfo.propertyCategory"
                @input="setChildType"
              >
                <el-radio
                  v-for="item in diConfig.PropertyCategory"
                  :key="item.dictionaryValue"
                  :disabled="!item.isUse"
                  :label="item.dictionaryValue"
                >
                  {{ item.dictionaryNameWithCulture }}
                </el-radio>
              </el-radio-group>
              <!-- <el-radio-group v-model="propertyInfo.propertyCategory" class="onlyChoose" :disabled="searchRes && conditions" @change="setChildType">
                                <el-radio :disabled="item.disable || !item.isUse" :label="item.dictionaryValue" v-for="item in diConfig.PropertyCategory" :key="item.dictionaryValue" >{{ item.dictionaryNameWithCulture }}</el-radio>
                            </el-radio-group> -->
            </el-form-item>
            <el-form-item
              v-if="propertyInfo.propertyCategory == 5 || propertyInfo.propertyCategory == 1 || propertyInfo.propertyCategory == 4"
              prop="subCategory"
            >
              <!-- 土地展示多选 -->
              <el-checkbox-group
                v-if="propertyInfo.propertyCategory == '5' || propertyInfo.propertyCategory == '4'"
                v-model="propertyInfo.subCategory"
                :disabled="searchRes && conditions"
                class="moreChoose"
              >
                <el-checkbox
                  v-for="citem in diConfig.ChildrenCategory"
                  :key="citem.dictionaryValue"
                  :disabled="!citem.isUse"
                  :label="citem.dictionaryValue"
                >
                  {{ citem.dictionaryNameWithCulture }}
                </el-checkbox>
              </el-checkbox-group>
              <el-checkbox-group
                v-else
                v-model="propertyInfo.subCategory"
                :disabled="searchRes && conditions"
                :max="2"
                class="moreChoose"
              >
                <el-checkbox
                  v-for="item in diConfig.ChildrenCategory"
                  :key="item.dictionaryValue"
                  :disabled="item.disable || !item.isUse"
                  :label="item.dictionaryValue"
                  @change="changeSub"
                >
                  {{ item.dictionaryNameWithCulture }}
                  <el-popover
                    v-if="item.dictionaryValue.includes('19')"
                    popper-class="hoverTip"
                    placement="top-start"
                    width="10"
                    trigger="hover"
                    content="服務式住宅租期至少在一個月以上，一年之內；由業主提供裝修，廚房，傢俬在內的全套家居設備，以及服務及維修在內的中央管理。"
                  >
                    <img
                      slot="reference"
                      class="imgTip"
                      src="../../../assets/hovertip.svg"
                      alt=""
                      @click.prevent="tipService"
                    >
                  </el-popover>
                </el-checkbox>
              </el-checkbox-group>
              <div
                v-if="showSubTxt == 'suc'"
                :class="['sub_tit',!propertyInfo.subCategory.length ? 'mar_10' : '']"
              >
                最多選擇2項，推薦更改為【{{ matchSubText }}】子類型
              </div>
              <div
                v-if="showSubTxt == 'pass'"
                :class="['sub_tit',!propertyInfo.subCategory.length ? 'mar_10' : '']"
              >
                建議選住宅子類型：【{{ matchSubText }}】
              </div>
              <div
                v-if="showSubTxt == 'fail'"
                :class="['sub_tit',!propertyInfo.subCategory.length ? 'mar_10' : '']"
              >
                建議重新選擇子類型，推薦更改為【{{ matchSubText }}】子類型
              </div>
              <!-- <el-radio-group v-else :disabled="searchRes && conditions" v-model="propertyInfo.subCategory" class="moreChoose">
                                <el-radio @change="changeSub" :label="item.dictionaryValue" v-for="item in diConfig.ChildrenCategory" :key="item.dictionaryValue">{{ item.dictionaryNameWithCulture }}</el-radio>
                            </el-radio-group> -->
            </el-form-item>
          </el-row>
          <!-- 工商厦 && 嘉丽格 中原 账户 展示-->
          <!-- 匹配成功后，樓盤物業類型及銷售機會編號不可修改 -->
          <el-row
            v-if="propertyInfo.propertyCategory === '2' && (companyCategory == 1 || companyCategory == 2)"
            :gutter="20"
            class="propertyNo"
          >
            <el-form-item
              label="銷售機會編號"
              prop="categoryNo"
            >
              <el-input
                v-model="propertyInfo.categoryNo"
                :disabled="searchRes"
                class="w320"
                type="text"
                maxlength="20"
                @input="saleChange($event)"
              />
              <el-button
                type="primary"
                class="w120 left_10"
                :disabled="!propertyInfo.categoryNo || searchRes"
                @click="checkRepeat(propertyInfo.categoryNo)"
              >
                搜尋
              </el-button>
              <div
                v-if="propertyNoRepeat && propertyInfo.categoryNo"
                class="el-form-item__error"
              >
                銷售機會編號已經存在
              </div>
            </el-form-item>
            <el-form-item
              v-if="!conditions || searchRes"
              label="物業編號"
              prop="propertyNo"
              class="mt_10"
            >
              <el-input
                v-model="propertyInfo.propertyNo"
                :disabled="searchRes"
                class="w320"
                type="text"
                maxlength="20"
                @blur="checkRepeat(propertyInfo.propertyNo)"
                @input="seaChange($event)"
              />
            </el-form-item>
          </el-row>
          <el-row
            v-else
            :gutter="20"
            class="propertyNo"
          >
            <el-form-item
              label="物業編號"
              prop="propertyNo"
            >
              <el-input
                v-if="conditions"
                ref="propertyNo"
                v-model="propertyInfo.propertyNo"
                :disabled="searchRes"
                class="w320"
                type="text"
                maxlength="20"
                @input="conChange($event)"
                @keyup.enter.native="checkRepeat(propertyInfo.propertyNo)"
              />
              <el-input
                v-else
                ref="propertyNo"
                v-model="propertyInfo.propertyNo"
                class="w320"
                type="text"
                maxlength="20"
                @blur="checkRepeat(propertyInfo.propertyNo)"
                @input="proChange($event)"
              />
              <el-button
                v-if="conditions"
                type="primary"
                class="w120 left_10"
                :disabled="!propertyInfo.propertyNo || searchRes"
                @click="checkRepeat(propertyInfo.propertyNo)"
              >
                搜尋
              </el-button>
              <span
                v-else
                class="EAA left_10"
              >EAA要求提供 (最多20字)</span>
              <!-- 利嘉阁物业同一代理人物业编号不能重复文案-->
              <div
                v-if="propertyNoRepeat && propertyInfo.propertyNo"
                class="el-form-item__error"
              >
                {{ promptinfo }}
              </div>
            </el-form-item>
          </el-row>
        </div>
      </div>
      <!-- 樓盤地址 -->
      <div
        v-if="!conditions || searchRes"
        class="address"
      >
        <h3>樓盤地址</h3>
        <div :class="['content', { disabledbutton: !propertyInfo.propertyCategory }]">
          <!-- 搜索输入 -->
          <div class="flexbuilA-flo">
            <div class="est_change">
              <el-form-item
                v-if="addressSearch"
                prop="estateName"
                label="屋苑或大廈名稱"
                :disabled="conditions"
              >
                <!-- w320 autoestatte-->
                <el-autocomplete
                  ref="autocomplete"
                  v-model="propertyInfo.estateName"
                  class="left_negative10 autoestatte"
                  :popper-class="dynamicClass"
                  :disabled="(fromZy && showZyAdress) || (mode === 'edit' && !editEst) || mode === '2' || conditions"
                  :fetch-suggestions="search"
                  placeholder="搜尋：屋苑或大廈名稱"
                  @keyup.backspace.native="cancelSearch"
                  @input="handleEstateInput"
                  @select="setEstate"
                >
                  <i
                    slot="prefix"
                    class="el-input__icon el-icon-search"
                  />
                  <template slot-scope="{item}">
                    <el-button
                      v-if="item.is_add"
                      class="add-button"
                      @click="changeSearch"
                    >
                      還未揾到屋苑？可按此手動輸入
                    </el-button>
                  </template>
                </el-autocomplete>
                <div
                  v-if="!addressSearch"
                  :class="[{grays :!fromZy},'zySty']"
                  @click="changeSearch"
                >
                  清空地址，切換字典搜索
                </div>
                <span
                  v-if="showZyAdress && formattedZyDate"
                  class="sign"
                >
                  <span class="sig_span">{{ formattedZyDate }}後可修改地址</span>
                  <tooltip
                    img-class-name="introtit"
                    tooltip-con="由於此盤使用了優惠券放盤，需<br/>待優惠券的放盤有效期屆滿後，<br/>方可進行屋苑地址的更改。"
                  />
                </span>
              </el-form-item>
              <el-select
                v-model="estateZoneCode"
                :disabled="(fromZy && showZyAdress) || (mode === 'edit' && !editEst) || mode === '2' || conditions || !propertyInfo.propertyCategory"
                class="pos_abs estatezone_sel"
                placeholder="地區"
                no-data-text="暫無數據"
                @visible-change="handleVisibleChange"
              >
                <el-option
                  label="全部"
                  :value="0"
                  @click.native="changeZoneCode('zonecode','')"
                />
                <el-option
                  v-for="item in diConfig.gscope"
                  :key="item.gscopeCode"
                  :value="item.gscopeCode"
                  :label="item.gscopeNameWithCulture"
                  @click.native="changeZoneCode('zonecode','firSelZone')"
                />
              </el-select>
            </div>
            <!-- <div class="addressName">
                            <el-form-item label="" prop="estateName" v-if="addressSearch" :disabled="conditions">
                                <el-autocomplete class="w320 left_negative10" :disabled="(mode === 'edit' && !editEst) || mode === '2' || conditions" v-model="propertyInfo.estateName" :fetch-suggestions="search" placeholder="搜尋：屋苑或大廈名稱" @select="setEstate" @blur="cancelSearch"></el-autocomplete>
                                <div class="blues" @click="changeSearch">手動輸入地區屋苑</div>
                                <span class="sign">© 中原樓市片區</span>
                            </el-form-item>
                        </div> -->
          </div>
          <!-- 手动录入信息 -->
          <div v-if="!addressSearch">
            <el-form-item
              label="地區"
              prop="gscopeFaCode"
              class="inline_block left_negative15"
            >
              <el-select
                v-model="propertyInfo.gscopeFaCode"
                class="choose left_5"
                :disabled="(mode === 'edit' && !editEst) || conditions"
                placeholder="請選擇"
                no-data-text="暫無數據"
              >
                <el-option
                  v-for="item in diConfig.gscope"
                  :key="item.gscopeCode"
                  :value="item.gscopeCode"
                  :label="item.gscopeNameWithCulture"
                  @click.native="setGscope(item)"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              label="樓市片區"
              prop="gscopeCode"
              class="inline_block"
            >
              <el-select
                v-model="propertyInfo.gscopeCode"
                class="choose"
                :disabled="(mode === 'edit' && !editEst) || conditions"
                placeholder="請選擇"
                no-data-text="暫無數據"
              >
                <el-option
                  v-for="item in diConfig.ChildrenGscope"
                  :key="item.gscopeCode"
                  :value="item.gscopeCode"
                  :label="item.gscopeNameWithCulture"
                  @click.native="setChType(item)"
                />
              </el-select>
            </el-form-item>
            <div
              v-show="propertyInfo.propertyCategory != 6"
              class="grays"
              @click="changeSearch"
            >
              清空地址，切換字典搜索
            </div>
            <!-- <span class="sign">© 中原樓市片區</span> -->
            <el-form-item
              label="屋苑或大廈名稱"
              prop="estateNameAll"
              class="left_negative15"
            >
              <el-input
                v-model="propertyInfo.estateName"
                prop="estateName"
                placeholder="請輸入屋苑或大廈中文名稱"
                :disabled="(mode === 'edit' && !editEst) || conditions"
                class="w320 left_5"
                maxlength="30"
                @input="editSelEstateName"
                @blur="addDraft('acquireId')"
              />
              <el-input
                v-model="propertyInfo.estateNameEN"
                prop="estateNameEN"
                placeholder="請輸入屋苑或大廈英文名稱"
                :disabled="(mode === 'edit' && !editEst) || conditions"
                class="w320 right_5"
                maxlength="60"
                @input="editSelEstateName"
                @blur="addDraft('acquireId')"
              />
            </el-form-item>
            <!-- <div class="estateNameEN"> -->
            <!-- <span class="left_10 tip">中文</span> -->
            <!-- <span class="left_10 tip">英文</span> -->
            <!-- </div> -->
          </div>
          <template v-if="addressSearch">
            <!-- 期数 搜索且输入了屋苑名称非村务(客制)时显示 && (propertyInfo.estateName && estAdress.phaseEstates.length)-->
            <el-row
              v-if="addressSearch && !isCutomadded && propertyInfo.propertyCategory !== 5 && estAdress.phaseEstates.length"
              :gutter="20"
            >
              <el-form-item
                label="期數"
                prop="phaseWithCulture"
                :rules="propertyInfo.propertyCategory == 1 && editNewDataRule ? rules.phaseWithCulture : [{ required: false }]"
              >
                <el-select
                  v-model="propertyInfo.phaseWithCulture"
                  class="w200"
                  :disabled="conditions || (fromZy && showZyAdress && couponPhase)"
                  placeholder="請選擇期數"
                  no-data-text="暫無數據"
                >
                  <el-option
                    v-for="(item, index) in estAdress.phaseEstates"
                    :key="index"
                    :label="item.phaseWithCulture"
                    :value="item.phaseWithCulture"
                    @click.native="setPhaBuild('phase', item)"
                  />
                </el-select>
              </el-form-item>
            </el-row>
            <!-- 座数 楼层 -->
            <el-row
              v-if="propertyInfo.propertyCategory !== '4' && propertyInfo.propertyCategory !== '5'"
              :gutter="20"
              class="flexbuilA-flo"
            >
              <div class="flexbuilA">
                <!-- propertyInfo.propertyCategory == 1 && !isCutomadded && showEstAdressbui && editNewDataRule -->
                <el-form-item
                  label="座數"
                  prop="buildingNameWithCulture"
                  :rules="isHaveTo ? rules.buildingNameWithCulture : [{ required: false }]"
                >
                  <!-- 村务客制手输 -->
                  <el-select
                    v-if="!isCutomadded && showEstAdressbui && propertyInfo.propertyCategory !== '3'"
                    v-model="propertyInfo.buildingNameWithCulture"
                    class="w150"
                    :popper-class="manualAdd ? 'custom-dropdown' : ''"
                    :disabled="conditions || (fromZy && showZyAdress && couponBuild)"
                    placeholder="請選擇座數"
                    no-data-text="暫無數據"
                  >
                    <el-option
                      v-for="(item, index) in estAdress.buildings"
                      :key="index"
                      :label="item.buildingNameWithCulture"
                      :value="item.buildingNameWithCulture"
                      @click.native="setPhaBuild('build', item)"
                    />
                    <div
                      v-if="manualAdd"
                      class="fixed-bottom-item"
                      @click="changeSearch"
                    >
                      還未搵到座數?可按此手動输入
                    </div>
                  </el-select>
                  <el-input
                    v-if="isCutomadded || !showEstAdressbui || propertyInfo.propertyCategory == '3'"
                    v-model="propertyInfo.buildingName"
                    :disabled="conditions"
                    class="w150"
                    @input="$forceUpdate()"
                    @blur="setPhaBuild('isCusbuild')"
                  />

                  <!-- 根据buildingID进行判断座数 -->
                  <!-- <el-select v-if="!isCutomadded && showEstAdressbui && propertyInfo.propertyCategory !== '3'" class="w150" :disabled="conditions" v-model="propertyInfo.buildingNameWithCulture" placeholder="請選擇座數" no-data-text="暫無數據">
                                        <el-option v-for="(item, index) in estAdress.buildings" :key="index" :label="item.buildingNameWithCulture" :value="item.buildingID" @click.native="setPhaBuild('build', item)"> </el-option>
                                    </el-select> -->
                </el-form-item>
              </div>
              <div
                ref="unitFloor"
                class="flexflo"
              >
                <!--  label="樓層" -->
                <el-form-item
                  class="build-form"
                  prop="floorNameAll"
                  :rules="propertyInfo.propertyCategory == '1' && propertyInfo.buildingType == 1 && editNewDataRule ? rules.floorName : [{ required: false }]"
                >
                  <template #label>
                    <span :class="{ buildlabel:( propertyInfo.propertyCategory == '2' || propertyInfo.propertyCategory == '1' ) && !propertyInfo.unitFloor && propertyInfo.topType == 3 && $route.query.gradeRule == 'starValidate'}">樓層</span>
                  </template>
                  <div class="build-Div build-Div-flo">
                    <template v-if="propertyInfo.propertyCategory == '1' && propertyInfo.buildingType == 1">
                      <!-- {{ estAdress.floorList }} -->
                      <el-select
                        v-if="estAdress.floorList.length"
                        v-model="propertyInfo.floorName"
                        prop="floorName"
                        class="w150"
                        :disabled="conditions || oneBuilFlo || startFloDis"
                        placeholder="請選擇樓層"
                        no-data-text="暫無數據"
                      >
                        <el-option
                          v-for="(item, index) in estAdress.floorList"
                          :key="index"
                          :label="`${item.floorName},${item.floorNameEN}`"
                          :value="item.floorName"
                          @click.native="setFlo(item)"
                        />
                      </el-select>
                      <tooltip
                        v-if="estAdress.floorList.length"
                        tooltip-con="同時顯示屋苑或大廈的中文英文樓層"
                      />
                      <el-select
                        v-if="estAdress.unitFloorList.length"
                        v-model="propertyInfo.unitFloor"
                        prop="unitFloor"
                        class="w150 build-sel"
                        :disabled="conditions || oneBuilFlo"
                        placeholder="請選擇高/中/低層"
                        no-data-text="暫無數據"
                      >
                        <el-option
                          v-for="(item, index) in estAdress.unitFloorList"
                          :key="index"
                          :label="item.dictionaryNameWithCulture"
                          :value="item.dictionaryValue"
                          @click.native="setFloExt"
                        />
                      </el-select>
                      <el-select
                        v-else
                        v-model="propertyInfo.unitFloor"
                        class="w150 build-sel"
                        :disabled="!!(conditions || oneBuilFlo || estAdress.floorList.length)"
                        placeholder="請選擇高/中/低層"
                        no-data-text="暫無數據"
                      >
                        <el-option
                          v-for="item in diConfig.UnitFloor"
                          :key="item.dictionaryValue"
                          :label="item.dictionaryNameWithCulture"
                          :value="item.dictionaryValue"
                          @click.native="selPlatImg('101','floSel')"
                        />
                      </el-select>
                      <tooltip
                        v-if="false || !estAdress.unitFloorList.length"
                        tooltip-con="根據總樓層數量除以3，分為高/中/低層"
                      />
                    </template>
                    <template v-else>
                      <el-select
                        v-model="propertyInfo.unitFloor"
                        :disabled="conditions || oneBuilFlo || startFloDis"
                        placeholder="請選擇高/中/低層"
                        no-data-text="暫無數據"
                        class="w180"
                      >
                        <el-option
                          v-for="item in diConfig.UnitFloor"
                          :key="item.dictionaryValue"
                          :label="item.dictionaryNameWithCulture"
                          :value="item.dictionaryValue"
                          @click.native="setFloExt"
                        />
                      </el-select>
                      <span
                        v-if="propertyInfo.propertyCategory == '2' && addressSearch"
                        class="starTips"
                      >星級盤必須選擇</span>
                    </template>
                  </div>
                </el-form-item>
              </div>
            </el-row>
            <!-- 车位楼层 -->
            <el-row
              v-if="addressSearch && propertyInfo.propertyCategory == '4'"
              :gutter="20"
            >
              <el-form-item label="樓層">
                <el-select
                  v-model="propertyInfo.unitFloor"
                  :disabled="conditions"
                  placeholder="請選擇高/中/低層"
                  no-data-text="暫無數據"
                  class="w180"
                >
                  <el-option
                    v-for="item in diConfig.UnitFloor"
                    :key="item.dictionaryValue"
                    :label="item.dictionaryNameWithCulture"
                    :value="item.dictionaryValue"
                    @click.native="setFloExt"
                  />
                </el-select>
              </el-form-item>
            </el-row>
            <!-- 单位 -->
            <el-row
              v-if="propertyInfo.propertyCategory !== '4' && propertyInfo.propertyCategory !== '5'"
              :gutter="20"
            >
              <el-form-item
                v-if="propertyInfo.propertyCategory == '1' && propertyInfo.buildingType == 1 && estAdress.unitList.length"
                label="單位"
              >
                <el-select
                  v-model="propertyInfo.roomNo"
                  class="w200"
                  :disabled="conditions || oneBuilRoom || startBuilRoom"
                  placeholder="請選擇單位"
                  no-data-text="暫無數據"
                >
                  <el-option
                    v-for="(item, index) in estAdress.unitList"
                    :key="index"
                    :label="item.roomNoWithCulture"
                    :value="item.roomNo"
                    @click.native="setRoomNo(item)"
                  />
                </el-select>
                <i
                  v-show="propertyInfo.roomNo"
                  class="posRno el-icon-close"
                  @click="clearVal('roomNo')"
                />
              </el-form-item>
              <!-- 独立屋等(234)手输单位 -->
              <el-form-item
                v-else
                label="單位"
              >
                <!-- :disabled="conditions || oneBuilRoom || startBuilRoom" -->
                <el-input
                  v-model="propertyInfo.roomNo"
                  :disabled="conditions"
                  maxlength="20"
                  class="w120"
                  @blur="setRoomNo"
                />
              </el-form-item>
            </el-row>
            <div
              v-if="propertyInfo.propertyCategory == '1' && (propertyInfo.buildingNameWithCulture || propertyInfo.buildingName) && companyCategory == 3"
              class="top-est"
            >
              樓盤資料絕對保密，樓層會以高/中/低層顯示{{ propertyInfo.rentalType == 1 ? '，用於估價功能(如有)' : '' }}
            </div>
          </template>

          <template v-else>
            <!-- 期数 -->
            <!-- <el-row :gutter="20">
                            <el-form-item label="期數">
                                <el-input class="w200" v-model="propertyInfo.phaseWithCulture"  @blur="setOneEstData"></el-input>
                            </el-form-item>
                        </el-row> -->
            <!-- 座数 楼层-->
            <el-row
              v-if="propertyInfo.propertyCategory !== '5'"
              :gutter="20"
              class="flexbuilA-flo"
            >
              <div
                v-if="propertyInfo.propertyCategory !== '4'"
                class="flexbuilA"
              >
                <el-form-item label="座數">
                  <el-input
                    v-model="propertyInfo.buildingName"
                    :disabled="conditions || (mode == 'edit' && !editNewDataRule)"
                    class="w150"
                    @blur="setOneEstData"
                    @input="$forceUpdate()"
                  />
                </el-form-item>
              </div>
              <div
                ref="unitFloor"
                :class="['flexflo', { flexCat: propertyInfo.propertyCategory == 4 }]"
              >
                <el-form-item
                  label="樓層"
                  class="build-form"
                >
                  <el-select
                    v-model="propertyInfo.unitFloor"
                    :disabled="conditions"
                    placeholder="請選擇高/中/低層"
                    no-data-text="暫無數據"
                    class="w180"
                  >
                    <el-option
                      v-for="item in diConfig.UnitFloor"
                      :key="item.dictionaryValue"
                      :label="item.dictionaryNameWithCulture"
                      :value="item.dictionaryValue"
                      @click.native="setOneEstData"
                    />
                  </el-select>
                  <span
                    v-if="(propertyInfo.propertyCategory == '1' || propertyInfo.propertyCategory == '2' || propertyInfo.propertyCategory == '6') && addressSearch"
                    class="starTips"
                  >星級盤必須選擇</span>
                </el-form-item>
              </div>
            </el-row>
            <!-- 单位 -->
            <el-row
              v-if="propertyInfo.propertyCategory !== '5' && propertyInfo.propertyCategory !== '4'"
              :gutter="20"
            >
              <el-form-item
                label="單位"
                class="build-form"
              >
                <el-input
                  v-model="propertyInfo.roomNo"
                  maxlength="20"
                  class="w120"
                  @blur="setOneEstData"
                />
              </el-form-item>
            </el-row>
          </template>
          <!-- 樓盤資料顯示 -->
          <el-row
            v-if="propertyDisPlayList.length && propertyDisPlayList[0].PropertyDisPlayType && companyCategory != 1"
            class="est-data"
            :gutter="20"
            :disabled="conditions"
          >
            <span
              v-if="propertyInfo.propertyCategory == '1'"
              class="starMust"
            >*</span>
            <el-form-item label="樓盤資料顯示">
              <div class="re-est">
                你的樓盤資料將會以此顯示在House730
              </div>
              <el-radio-group
                v-if="propertyDisPlayList.length > 1"
                v-model="propertyInfo.propertyDisPlayType"
                class="est-radio"
                @change="changeDisplayType"
              >
                <el-radio
                  v-for="item in propertyDisPlayList"
                  :key="item.PropertyDisPlayType"
                  :label="item.PropertyDisPlayType"
                >
                  {{ item.estDatawithCulture }}
                </el-radio>
              </el-radio-group>
              <div
                v-if="propertyDisPlayList.length == 1"
                class="est-tit"
              >
                <span
                  v-for="item in propertyDisPlayList"
                  :key="item.PropertyDisPlayType"
                >
                  {{ item.estDatawithCulture }}
                </span>
              </div>
            </el-form-item>
          </el-row>
          <!-- 樓盤地址 楼龄 -->
          <el-row
            :gutter="20"
            :disabled="conditions"
          >
            <el-form-item label="街道名稱及號碼">
              <!-- :placeholder="!addressSearch ? ' 如:天湖路1號' : ''" -->
              <el-input
                v-model="propertyInfo.estateAddress"
                :disabled="addressSearch || conditions || disableAddress"
                maxlength="20"
                class="w320"
              />
              <tooltip
                v-if="!addressSearch"
                tooltip-con="所輸入的內容，將會在樓盤詳情頁顯示，請不要輸入完整地址<br/>輸入格式如：天湖路1號"
              />
              <div
                v-if="propertyInfo.propertyCategory != '5'"
                class="build-Div"
              >
                <span>樓齡</span>
                <el-input
                  v-model="propertyInfo.buildingAge"
                  :disabled="addressSearch || JSON.stringify(EstateInfo) != '{}' || conditions"
                  maxlength="20"
                  class="w120"
                  @input="onlyNumber(propertyInfo.buildingAge, 'buildingAge')"
                  @blur="limitAgeRange"
                />
              </div>
            </el-form-item>
          </el-row>
          <!-- 房間數目 -->
          <el-row
            v-if="propertyInfo.propertyCategory !== '4' && propertyInfo.propertyCategory !== '5'"
            ref="roomNumber"
            :gutter="20"
            :disabled="conditions"
          >
            <!-- label="房間數目" -->
            <el-form-item>
              <template #label>
                <span :class="{ red: (!propertyInfo.roomNumber || propertyInfo.roomNumber == '') && (propertyInfo.propertyCategory == '1' || propertyInfo.propertyCategory == '6') && propertyInfo.topType == 3 && $route.query.gradeRule == 'starValidate'}">房間數目</span>
              </template>
              <el-select
                v-model="propertyInfo.roomNumber"
                :disabled="conditions"
                placeholder="請選擇房間數目"
                no-data-text="暫無數據"
                class="w180"
              >
                <el-option
                  v-for="item in diConfig.RoomNumber"
                  :key="item.dictionaryValue"
                  :label="item.dictionaryNameWithCulture"
                  :value="item.dictionaryValue"
                  @click.native="setRoomNumber(item)"
                />
              </el-select>
              <i
                v-show="propertyInfo.roomNumber"
                class="posicon posabsrom el-icon-close"
                @click="clearVal('roomNumber')"
              />
              <div class="starBlock">
                <div class="starBox">
                  <span
                    v-if="isUseStar && (propertyInfo.propertyCategory == 1 || propertyInfo.propertyCategory == 6)"
                    class="starTips"
                  >星級盤必須選擇</span>
                  <span
                    v-if="isUseInstantEstateVolume && propertyInfo.propertyCategory == 1"
                    class="starTips"
                  >
                    同戶型即時盤量資訊需要選擇房間數目後展示
                    <tooltip tooltip-con="即時盤量會顯示同區同戶型和<br/>同屋苑同戶型樓盤價位分佈圖，<br/>平均價格和同區競爭盤量。" />
                  </span>
                </div>
              </div>
              <div
                v-if="propertyInfo.propertyCategory !== '2' && propertyInfo.propertyCategory !== '3'"
                class="build-Div toildiv"
              >
                <span>洗手間數目</span>
                <el-select
                  v-model="propertyInfo.toiletNumber"
                  :disabled="conditions && disSelToil"
                  placeholder="請選擇洗手間數目"
                  no-data-text="暫無數據"
                  class="w180"
                >
                  <el-option
                    v-for="item in diConfig.ToiletNumber"
                    :key="item.dictionaryValue"
                    :label="item.dictionaryNameWithCulture"
                    :value="item.dictionaryValue"
                    @click.native="changeToilet(item)"
                  />
                </el-select>
                <i
                  v-show="propertyInfo.toiletNumber"
                  class="posicon postoil el-icon-close"
                  @click="clearVal('toiletNumber')"
                />
              </div>
            </el-form-item>
          </el-row>
        </div>
      </div>
      <!-- 银行估价 && (!conditions || searchRes)-->
      <div v-if="bankVal && isShowBoc && propertyInfo.rentalType == 1">
        <div class="ageHide">
          <div class="ageTitle">
            <h3>銀行估價</h3>
          </div>
          <div class="content">
            <el-row :gutter="20">
              <el-form-item label="銀行估價">
                <el-checkbox v-model="propertyInfo.isBoc" />
                <span style="font-size: 14px">&nbsp;&nbsp;開啟</span>
                <div class="bankques">
                  開啟後，用戶可在樓盤詳情頁中使用銀行估價功能（如有）<br>即時物業估值服務由中國銀行(香港)有限公司委託第三方提供，僅供參考。
                </div>
              </el-form-item>
            </el-row>
            <div
              v-if="showBankAll"
              style="margin-left:160px"
            >
              <div class="bankAll">
                即時物業估值
              </div>
              <template v-if="showBankEva">
                <div class="evaboxo">
                  <img
                    src="../../../assets/post-bank.png"
                    alt="##"
                  >
                  <el-button
                    v-if="showEvaBut"
                    type="primary"
                    :disabled="!evalue"
                    @click="geteva"
                  >
                    即時物業估值
                  </el-button>
                  <el-button
                    v-else
                    style="background-color:#990033;border-color:#990033;color:#ffffff"
                  >
                    樓價估值 ${{ evaluationValue }}萬
                  </el-button>
                  <div v-if="!showEvaBut">
                    估價日期：{{ evaluationDate }}
                  </div>
                </div>
                <div
                  v-if="showAgreeEva"
                  class="evaboxt"
                >
                  <div class="checkdiv">
                    <el-checkbox v-model="evalue" />
                  </div>
                  <div>
                    本人/本人等已閱讀及明白中國銀行（香港）有限公司的即時物業估值<br>服務之 <a
                      class="bocCla"
                      target="_blank"
                      href="https://www.bochk.com/dam/mortgage/valuation_tnc_tc.pdf"
                    >條款及細則</a>，並同意受其約束。<br>此即時物業估值服務由中國銀行（香港）有限公司委託第三方提供，<br>僅供參考。
                  </div>
                </div>
                <div
                  v-else
                  class="tipdiv"
                >
                  此即時物業估值服務由中國銀行(香港)有限公司委託第三方提供，僅供參考。
                </div>
              </template>
              <template v-else>
                <div class="hbox">
                  即時物業估值
                </div>
                <div class="imgtipbox">
                  <img
                    src="../../../assets/post-warning.png"
                    alt=""
                  >
                  <span>我們暫時未能為你提供所需的即時物業估值。</span>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <!-- 樓盤價格及面積 -->
      <div
        v-if="!conditions || searchRes"
        class="area"
      >
        <h3>樓盤價格及面積</h3>
        <div class="content">
          <el-row
            v-if="propertyInfo.rentalType == 1"
            :gutter="20"
          >
            <el-form-item
              v-if="!propertyInfo.subCategory.includes('6') && !propertyInfo.subCategory.includes('7') && !propertyInfo.subCategory.includes(6) && !propertyInfo.subCategory.includes(7)"
              label="放售價"
              prop="salePrice"
            >
              <el-input
                ref="elsalePrice"
                v-model="propertyInfo.salePrice"
                class="w120"
                type="text"
                maxlength="12"
                @input="onlyNumber(propertyInfo.salePrice, 'salePrice')"
                @blur="Unit('sale', propertyInfo.salePrice)"
              />
              <span class="grayW left_10 right_10">萬元</span>
              <span v-if="isOwner || isShowOwner">
                <el-checkbox
                  :value="isPropertySource"
                  @input="changePropertySource('propertySource')"
                />
                <span class="rentOpens right_10">業主盤</span>
              </span>
              <!-- 业主盘后台开关开启时，只有 -->
              <span v-if="propertyInfo.rentalType == 1">
                <el-checkbox
                  :value="propertyInfo.isForeclosure"
                  @input="changeClosureAnddesc('isForeclosure')"
                />
                <span class="rentOpens right_10">銀主盤</span>
              </span>
              <span v-if="propertyInfo.rentalType == 1 && propertyInfo.isForeclosure">
                <el-checkbox
                  :value="propertyInfo.isShowForeclosureDesc"
                  @input="changeClosureAnddesc('isShowForeclosureDesc')"
                />
                <span class="rentTips">放售價旁會加上"+符號，代表實際售價 可能會高於標<br>示售價，但買家可以以標示的價格作為議價的起點</span>
              </span>
            </el-form-item>
            <!-- <el-form-item prop="paidSalePrice" :rules="propertyInfo.subCategory == '6' || propertyInfo.subCategory == '7' ? rules.paidSalePrice : [{ required: false }]" v-show="propertyInfo.subCategory == '6' || propertyInfo.subCategory == '7'" label="放售價"> -->
            <el-form-item
              v-show="propertyInfo.subCategory.includes('6') ||propertyInfo.subCategory.includes('7')|| propertyInfo.subCategory.includes(6) ||propertyInfo.subCategory.includes(7) "
              prop="paidSalePrice"
              :rules="propertyInfo.subCategory.includes('6') || propertyInfo.subCategory.includes('7')|| propertyInfo.subCategory.includes(6) ||propertyInfo.subCategory.includes(7) ? rules.paidSalePrice : [{ required: false }]"
              label="放售價"
            >
              <span class="normal">未補地價</span>
              <el-input
                v-model="propertyInfo.unPaidSalePrice"
                class="w150 left_16"
                type="text"
                maxlength="12"
                @input="onlyNumber(propertyInfo.unPaidSalePrice, 'unPaidSalePrice')"
                @blur="isShowReaduce('unPaidSalePrice','firstUnPaidSalePrice','isReduceUnpaid','isReduceUnPaidSalePrice')"
              />
              <span class="gray left_10 right_50">萬元</span>
              <span class="normal">已補地價</span>
              <el-input
                v-model="propertyInfo.paidSalePrice"
                class="w150 left_16"
                type="text"
                maxlength="12"
                @input="onlyNumber(propertyInfo.paidSalePrice, 'paidSalePrice')"
                @blur="isShowReaduce('paidSalePrice','firstPaidSalePrice','isReducePaid','isReducePaidSalePrice')"
              />
              <span class="gray left_10 right_10">萬元</span>
              <span v-if="isOwner || isShowOwner">
                <el-checkbox
                  :value="isPropertySource"
                  @input="changePropertySource('propertySource')"
                />
                <span class="rentOpens right_10">業主盤</span>
              </span>
              <span v-if="propertyInfo.rentalType == 1">
                <el-checkbox
                  :value="propertyInfo.isForeclosure"
                  @input="changeClosureAnddesc('isForeclosure')"
                />
                <span class="rentOpens right_10">銀主盤</span>
              </span>
              <span v-if="propertyInfo.rentalType == 1 && propertyInfo.isForeclosure">
                <el-checkbox
                  :value="propertyInfo.isShowForeclosureDesc"
                  @input="changeClosureAnddesc('isShowForeclosureDesc')"
                />
                <span class="rentTips">放售價旁會加上"+符號，代表實際售價 可能會高於標<br>示售價，但買家可以以標示的價格作為議價的起點</span>
              </span>
            </el-form-item>
          </el-row>
          <el-row
            v-else
            :gutter="20"
          >
            <el-form-item
              label="放租價"
              prop="rentPrice"
            >
              <el-input
                v-model="propertyInfo.rentPrice"
                class="w120"
                maxlength="12"
                @input="onlyNumber(propertyInfo.rentPrice, 'rentPrice')"
                @blur="Unit('rent', propertyInfo.rentPrice)"
              />
              <span class="red left_10 right_10">每月租金</span>
              <span v-if="isOwner || isShowOwner">
                <el-checkbox
                  :value="isPropertySource"
                  @input="changePropertySource('propertySource')"
                />
                <span class="rentOpens right_10">業主盤</span>
              </span>
            </el-form-item>
          </el-row>
          <el-row
            v-if="showReducePrice"
            class="inputVr"
            :gutter="20"
          >
            <el-form-item label="">
              <span class="inputVr-label">減價盤</span>
              <tooltip tooltip-con="選擇後會在House730顯示減<br/>價比率, 最大比率為30%" />
              <el-checkbox
                v-if="isReduceUnpaid"
                v-model="propertyInfo.isReduceUnPaidSalePrice"
              >
                開啟(未補)
              </el-checkbox>
              <span
                v-if="isReduceUnpaid && isReducePaid"
                class="inputVr-label"
              >減價盤</span>
              <tooltip
                v-if="isReduceUnpaid && isReducePaid"
                tooltip-con="選擇後會在House730顯示減<br/>價比率, 最大比率為30%"
              />
              <el-checkbox
                v-if="isReducePaid"
                v-model="propertyInfo.isReducePaidSalePrice"
              >
                開啟{{ propertyInfo.subCategory.includes('6') ||propertyInfo.subCategory.includes('7')|| propertyInfo.subCategory.includes(6) ||propertyInfo.subCategory.includes(7)?'(已補)':'' }}
              </el-checkbox>
              <el-checkbox
                v-if="rentReducePrice"
                v-model="propertyInfo.isReduceRentPrice"
              >
                開啟
              </el-checkbox>
            </el-form-item>
          </el-row>

          <!-- 建築/實用 面積 -->
          <el-row
            v-if="propertyInfo.propertyCategory !== '4'"
            :gutter="20"
          >
            <el-form-item
              label="面積(呎)"
              prop="buildingArea"
            >
              <span class="normal">實用</span>
              <el-input
                v-model="propertyInfo.saleableArea"
                class="w150 right_50 left_10"
                :disabled="conditions"
                maxlength="12"
                @input="onlyNumber(propertyInfo.saleableArea, 'saleableArea')"
              />
              <span class="normal">建築</span>
              <el-input
                v-model="propertyInfo.buildingArea"
                class="w150 left_10 right_10 "
                :disabled="conditions"
                maxlength="12"
                @input="onlyNumber(propertyInfo.buildingArea, 'buildingArea')"
              />
              <div
                v-if="(propertyInfo.subCategory && (propertyInfo.subCategory.includes(11)||propertyInfo.subCategory.includes('11')||propertyInfo.subCategory.includes(8)||propertyInfo.subCategory.includes('8')) && propertyInfo.propertyCategory ==1) || (propertyInfo.propertyCategory && propertyInfo.propertyCategory!='1' && propertyInfo.propertyCategory !='4')"
                class="inline-tip"
              >
                <el-checkbox v-model="isArea">
                  面積未核實
                </el-checkbox>
                <tooltip tooltip-con="如面積未核實，<br/>須註明並會在House730網頁上顯示。" />
              </div>
            </el-form-item>
          </el-row>
          <!-- @change="changeForeclosure"  v-model="propertyInfo.isForeclosure"-->
          <!-- <el-row :gutter="20" v-if="propertyInfo.rentalType == 1">
                        <el-form-item label="銀主盤" prop="isForeclosure">
                            <el-checkbox @input="changeClosureAnddesc('isForeclosure')" :value="propertyInfo.isForeclosure"></el-checkbox>
                            <span class="rentOpen">&nbsp;&nbsp;開啟</span>
                        </el-form-item>
                    </el-row>
                    <el-row :gutter="20" v-if="propertyInfo.rentalType == 1 && propertyInfo.isForeclosure">
                        <el-form-item label="最低放售價" prop="isShowForeclosureDesc">
                            <el-checkbox @input="changeClosureAnddesc('isShowForeclosureDesc')" :value="propertyInfo.isShowForeclosureDesc"></el-checkbox>
                            <span class="rentOpen">&nbsp;&nbsp;開啟&nbsp;&nbsp;</span>
                            <span class="rentTip">開啟最低放售價後，放售價旁會加上"+"符號，代表實際售價可能會高於標示售價，但買家可以以標示的價格作為議價的起點</span>
                        </el-form-item>
                    </el-row> -->

          <!-- 起租日 -->
          <el-row
            v-if="propertyInfo.rentalType == 2"
            :gutter="20"
          >
            <el-form-item
              label="起租日"
              prop="beginRentTime"
            >
              <el-date-picker
                v-model="propertyInfo.beginRentTime"
                :disabled="conditions"
                class="w180"
                type="date"
                placeholder="可隨時起租"
                value-format="timestamp"
              />
            </el-form-item>
          </el-row>
          <!-- 其他選項 -->
          <el-row
            v-if="propertyInfo.rentalType == 2 && propertyInfo.propertyCategory != '4' && propertyInfo.propertyCategory != '5'"
            :gutter="20"
          >
            <el-form-item label="其他選項">
              <el-checkbox-group v-model="propertyInfo.rentLabel">
                <el-checkbox
                  v-for="item in diConfig.RentLabel"
                  :key="item.dictionaryValue"
                  :label="item.dictionaryValue"
                  :disabled="disRentLabel(item)"
                >
                  {{ item.dictionaryNameWithCulture }}
                  <el-popover
                    popper-class="hoverTip"
                    placement="top-start"
                    width="10"
                    trigger="hover"
                    content="共居租期通常至少一個月以上。業主負責提供裝修完善的住宅空間，包括必要的家具和共享的公共區域，如廚房、客廳和浴室等。每位租戶擁有自己的私人臥室，同時需要共用公共區域。​"
                  >
                    <img
                      v-if="item.dictionaryValue == 8"
                      slot="reference"
                      class="imgTip"
                      src="../../../assets/hovertip.svg"
                      alt=""
                      @click.prevent="tipService"
                    >
                  </el-popover>
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-row>
          <!-- 每月管理費 -->
          <!-- <el-row :gutter="20" v-if="propertyInfo.propertyCategory != '4'">
                        <el-form-item label="每月管理費">
                            <el-col :span="2">
                                <el-input :disabled="conditions" v-model="propertyInfo.propertyManagementFee" maxlength="6" @input="onlyNumber(propertyInfo.propertyManagementFee, 'propertyManagementFee')"></el-input>
                            </el-col>
                            <el-col :span="1">
                                <span class="maxLength">元</span>
                            </el-col>
                        </el-form-item>
                    </el-row> -->
        </div>
      </div>
      <!-- 平面图  住宅 选了屋苑 且有平面图-->
      <div
        v-if="(propertyInfo.floorName || propertyInfo.roomNo) && propertyInfo.estateID && propertyInfo.propertyCategory == 1 && (!conditions || searchRes) && propertyInfo.buildingType == 1"
        class="planImg"
      >
        <div class="pImg_tit">
          <h3>平面圖</h3>
          <span class="ques">＠House730提供</span>
        </div>
        <div class="content">
          <!-- 有筛选项但无数据时 -->
          <div
            v-if="alreaSel == true"
            style="height: 120px"
          >
            <div class="wudata">
              <img src="@/assets/wudata.svg">
              <span>目前尚未提供相關平面圖，您仍可繼續進行放盤。<br></span>
              <span>如需補充平面圖，可隨時在下方自行上傳</span>
            </div>
          </div>
          <div
            v-if="platUrls.length !== 0 && alreaSel == false"
            class="plaImgBox"
          >
            <div
              v-for="(url, index) in platUrls"
              :key="index"
              class="imgbox"
            >
              <div class="imgxixi">
                <el-image
                  style="width: 180px; height: 180px"
                  lazy
                  :src="url.imagePath + '?x-oss-process=style/300xauto_f'"
                  @click="changeP(url, index)"
                />
                <el-checkbox
                  v-model="planChecked"
                  class="planbox"
                  :label="url"
                  :disabled="lijiageAco"
                  @change="changeCheck"
                >
                  <br>
                </el-checkbox>
              </div>
              <div>單位平面圖</div>
            </div>
            <el-dialog
              class="bigimgdia"
              title="提示"
              :visible.sync="aPlat"
            >
              <el-carousel
                v-if="aPlat == true"
                class="postCar"
                trigger="click"
                indicator-position="none"
                :initial-index="nPlat"
                height="560px"
                direction="horizontal"
                :autoplay="false"
              >
                <el-carousel-item
                  v-for="(it, index) in platUrls"
                  :key="index"
                >
                  <img
                    :src="it.imagePath + '?x-oss-process=style/640x480_c'"
                    alt=""
                  >
                  <div class="medium">
                    {{ it.imageDesc }}
                  </div>
                </el-carousel-item>
              </el-carousel>
              <img
                style="width: 39px; height: 46px; z-index: 2088; position: absolute; top: -15px; right: -51px"
                src="@/assets/guanbi.svg"
                @click="changePdia('plat')"
              >
            </el-dialog>
          </div>
          <!-- 楼层平面图 -->
          <div
            v-if="floUrls.length !== 0 && alreaSel == false"
            class="plaImgBox"
          >
            <div
              v-for="(url, index) in floUrls"
              :key="index"
              class="imgbox"
            >
              <!-- :preview-src-list="floPlaturls(index)" -->
              <div class="imgxixi">
                <el-image
                  ref="elimage"
                  style="width: 180px; height: 180px"
                  lazy
                  :src="url.imagePath + '?x-oss-process=style/300xauto_f'"
                  @click="changeF(url, index)"
                />
                <el-checkbox
                  v-model="planfloChecked"
                  class="planbox"
                  :label="url"
                  :disabled="lijiageAco"
                  @change="changeFloCheck"
                >
                  <br>
                </el-checkbox>
              </div>
              <div>樓層平面圖</div>
            </div>
            <el-dialog
              class="bigimgdia"
              title="提示"
              :visible.sync="aFlor"
            >
              <el-carousel
                v-if="aFlor == true"
                class="postCar"
                trigger="click"
                indicator-position="none"
                :initial-index="nFlor"
                height="560px"
                direction="horizontal"
                :autoplay="false"
              >
                <el-carousel-item
                  v-for="(it, index) in floUrls"
                  :key="index"
                >
                  <img
                    :src="it.imagePath + '?x-oss-process=style/640x480_c'"
                    alt=""
                  >
                  <div class="medium">
                    {{ it.imageDesc }}
                  </div>
                </el-carousel-item>
              </el-carousel>
              <img
                style="width: 39px; height: 46px; z-index: 2088; position: absolute; top: -15px; right: -51px"
                src="@/assets/guanbi.svg"
                @click="changePdia('flo')"
              >
            </el-dialog>
          </div>
        </div>
      </div>
      <!-- 樓盤資料 -->
      <div
        v-if="!conditions || searchRes"
        class="data"
      >
        <h3>樓盤資料</h3>
        <div class="content">
          <el-row
            ref="titleCN"
            :gutter="20"
          >
            <el-form-item
              ref="titleCN"
              prop="titleCN"
            >
              <template #label>
                <span :class="{ buildlabel:propertyInfo.titleCN.trim().length < 8 && propertyInfo.topType == 3 && $route.query.gradeRule == 'starValidate'}">放盤標題</span>
              </template>
              <!-- 失焦判断是否含有敏感词 (PMS06修改标题空格规则.trim) -->
              <el-input
                v-model="propertyInfo.titleCN"
                type="text"
                maxlength="30"
                class="w500"
                show-word-limit
                @input="sensitive('titleCN', propertyInfo.titleCN)"
              />
              <i
                class="commonWord wordPos"
                @click="openCommon(1)"
              >選擇常用詞</i>
              <span class="maxLength left_10">中文（最多30字）</span>
              <div
                v-if="propertyInfo.titleCN && hasSenWrods.titleCN"
                class="el-form-item__error"
              >
                內容不符合會員條款無法刊登
              </div>
              <span
                v-if="isUseStar"
                class="starTips"
              >星級盤中文標題必須不少於8個字</span>
            </el-form-item>
          </el-row>
          <el-row :gutter="20">
            <el-form-item
              label=""
              prop="titleEN"
            >
              <el-input
                v-model="propertyInfo.titleEN"
                maxlength="50"
                class="w500 left_20"
                show-word-limit
                @input="sensitive('titleEN', propertyInfo.titleEN)"
              />
              <span class="maxLength left_10">英文（最多50字）</span>
              <div
                v-if="propertyInfo.titleEN && hasSenWrods.titleEN"
                class="el-form-item__error"
              >
                內容不符合會員條款無法刊登
              </div>
            </el-form-item>
          </el-row>
          <el-row :gutter="20">
            <el-form-item
              label="樓盤介紹"
              prop="introduceCN"
              class="introlabel"
            >
              <tooltip
                img-class-name="introtit"
                tooltip-con="如需要輸入超連結，例如「https://www.example.com」，請複製以下格式輸入：<br/>link>>><span style='color:#E50113'>https://www.example.com</span><<&ltlink"
              />
              <p
                class="txtcopy"
                @click="onCopy('link>>>https://www.example.com<<<link')"
              >
                複製超連結格式
              </p>
              <el-input
                v-model="propertyInfo.introduceCN"
                type="textarea"
                maxlength="500"
                resize="none"
                show-word-limit
                class="w500 introduceCN"
                @input="sensitive('introduceCN', propertyInfo.introduceCN)"
              />
              <i
                class="commonWord wordPos"
                @click="openCommon(2)"
              >選擇常用詞</i>
              <span class="maxLength left_10">
                中文（最多500字）
              </span>
              <div
                v-if="propertyInfo.introduceCN && hasSenWrods.introduceCN"
                class="el-form-item__error"
              >
                內容不符合會員條款無法刊登
              </div>
            </el-form-item>
          </el-row>
          <el-row
            :gutter="20"
            style="height: 95px"
          >
            <el-form-item
              label=""
              prop="introduceEN"
            >
              <el-input
                v-model="propertyInfo.introduceEN"
                type="textarea"
                maxlength="600"
                show-word-limit
                resize="none"
                class="w500 left_20"
                @input="sensitive('introduceEN', propertyInfo.introduceEN)"
              />
              <span class="maxLength left_10">
                英文（最多600字）
              </span>
              <div
                v-if="propertyInfo.introduceEN && hasSenWrods.introduceEN"
                class="el-form-item__error"
              >
                內容不符合會員條款無法刊登
              </div>
            </el-form-item>
          </el-row>
          <el-row
            v-if="propertyInfo.subCategory && (propertyInfo.subCategory.includes('19') || propertyInfo.subCategory.includes(19))"
            :gutter="20"
          >
            <el-form-item
              class="introlabel"
              label="設施及服務"
              prop="servicesCN"
            >
              <tooltip
                img-class-name="introtit"
                tooltip-con="如需要輸入超連結，例如「https://www.example.com」，請複製以下格式輸入：<br/>link>>><span style='color:#E50113'>https://www.example.com</span><<&ltlink"
              />
              <p
                class="txtcopy"
                @click="onCopy('link>>>https://www.example.com<<<link')"
              >
                複製超連結格式
              </p>
              <el-input
                v-model="propertyInfo.servicesCN"
                type="textarea"
                maxlength="500"
                show-word-limit
                resize="none"
                class="w500 introduceCN"
                @input="$forceUpdate()"
              />
              <i
                class="commonWord wordPos"
                @click="openCommon(3)"
              >選擇常用詞</i>
              <span class="maxLength left_10">
                中文（最多500字）
              </span>
              <div
                v-if="propertyInfo.servicesCN && hasSenWrods.servicesCN"
                class="el-form-item__error"
              >
                內容不符合會員條款無法刊登
              </div>
            </el-form-item>
          </el-row>
          <el-row
            v-if="propertyInfo.subCategory.includes('19') || propertyInfo.subCategory.includes(19)"
            :gutter="20"
            style="height: 95px"
          >
            <el-form-item
              label=""
              prop="servicesEN"
            >
              <el-input
                v-model="propertyInfo.servicesEN"
                type="textarea"
                maxlength="600"
                resize="none"
                show-word-limit
                class="w500 left_20"
                @input="$forceUpdate()"
              />
              <span class="maxLength left_10">
                英文（最多600字）
              </span>
              <div
                v-if="propertyInfo.servicesEN && hasSenWrods.servicesEN"
                class="el-form-item__error"
              >
                內容不符合會員條款無法刊登
              </div>
            </el-form-item>
          </el-row>
        </div>
      </div>

      <!-- 楼盘标签(!conditions || searchRes) &&  -->
      <div
        v-if="propertyInfo.propertyCategory !== '5' && (!conditions || searchRes) "
        class="protags"
      >
        <div class="tags_tit">
          <h3>樓盤標籤</h3>
        </div>
        <div class="content">
          <el-row
            v-if="propertyInfo.propertyCategory == '' || !propertyInfo.propertyCategory || propertyInfo.propertyCategory == '1' || propertyInfo.propertyCategory == '6' || propertyInfo.propertyCategory == '2' "
            :gutter="20"
            class="cate cateone"
          >
            <div
              v-if="isFirst"
              class="jiachewei"
            >
              <div class="guifea">
                <span>單位特色</span>
                <span>最多選擇4個</span>
                <span><input
                  id="check1"
                  type="checkbox"
                  disabled
                >連車位</span>
              </div>
              <span><input
                id="check1"
                type="checkbox"
                disabled
              >連車位</span>
              <span><input
                id="check1"
                type="checkbox"
                disabled
              >連花園</span>
              <span><input
                id="check1"
                type="checkbox"
                disabled
              >連露台</span>
              <span><input
                id="check1"
                type="checkbox"
                disabled
              >連天台</span>
              <span><input
                id="check1"
                type="checkbox"
                disabled
              >連平台</span>
              <span><input
                id="check1"
                type="checkbox"
                disabled
              >連租約</span>
              <span><input
                id="check1"
                type="checkbox"
                disabled
              >複式</span>
              <span><input
                id="check1"
                type="checkbox"
                disabled
              >全層</span>
              <span><input
                id="check1"
                type="checkbox"
                disabled
              >相連</span>
            </div>
            <el-form-item
              v-if="!isFirst"
              label="單位特色"
            >
              <span class="tags_geshu">最多選擇4個</span>
              <el-checkbox-group
                v-model="tagsChar"
                :max="4"
                class="moreChoose moreChooseone charBox"
                :disabled="propertyInfo.propertyCategory == '' || !propertyInfo.propertyCategory"
                @change="changeTags(tagsChar,0)"
              >
                <el-checkbox
                  v-for="(citem, s) in diConfig.ChildrenTag[0]"
                  :key="citem.dictionaryValue"
                  :class="`devicPosition${s}`"
                  :label="citem.dictionaryValue"
                >
                  {{ citem.dictionaryNameWithCulture }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-row>
          <el-row
            v-if="propertyInfo.propertyCategory == '' || !propertyInfo.propertyCategory || propertyInfo.propertyCategory == '1' || propertyInfo.propertyCategory == '6' || propertyInfo.propertyCategory == 2"
            :gutter="20"
            class="cate"
          >
            <el-form-item label="景觀">
              <span class="tags_geshu">最多選擇1個</span>
              <el-checkbox-group
                v-model="tagsSce"
                :max="1"
                class="moreChoose"
                :disabled="propertyInfo.propertyCategory == '' || !propertyInfo.propertyCategory"
                @change="changeTags(tagsSce,1)"
              >
                <el-checkbox
                  v-for="citem in diConfig.ChildrenTag[1]"
                  :key="citem.dictionaryValue"
                  :label="citem.dictionaryValue"
                >
                  {{ citem.dictionaryNameWithCulture }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-row>
          <el-row
            v-if="propertyInfo.propertyCategory == '' || !propertyInfo.propertyCategory || propertyInfo.propertyCategory !== '4'"
            :gutter="20"
            class="cate"
          >
            <el-form-item label="裝修">
              <span class="tags_geshu">最多選擇1個</span>
              <el-checkbox-group
                v-model="tagsRen"
                :max="1"
                class="moreChoose"
                :disabled="propertyInfo.propertyCategory == '' || !propertyInfo.propertyCategory"
                @change="changeTags(tagsRen,2)"
              >
                <el-checkbox
                  v-for="citem in diConfig.ChildrenTag[2]"
                  :key="citem.dictionaryValue"
                  :label="citem.dictionaryValue"
                >
                  {{ citem.dictionaryNameWithCulture }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-row>
          <el-row
            v-if="propertyInfo.propertyCategory !== '4'"
            :gutter="20"
            class="cate"
          >
            <el-form-item label="配套">
              <span class="tags_geshu">最多選擇3個</span>
              <el-checkbox-group
                v-model="tagsMat"
                :max="3"
                class="moreChoose"
                :disabled="propertyInfo.propertyCategory == '' || !propertyInfo.propertyCategory"
                @change="changeTags(tagsMat,3)"
              >
                <el-checkbox
                  v-for="citem in diConfig.ChildrenTag[3]"
                  :key="citem.dictionaryValue"
                  :disabled="citem.dictionaryValue == 23 && subway > 15"
                  :label="citem.dictionaryValue"
                >
                  <p
                    v-if="citem.dictionaryValue == 23"
                    style="color: red; display: inline-block"
                  >
                    #
                  </p>
                  {{ citem.dictionaryNameWithCulture }}
                </el-checkbox>
              </el-checkbox-group>
              <span
                v-if="addressSearch && subway != -1 && Object.keys(EstateInfo).length"
                class="tags_sub"
              ><p style="color: red; display: inline-block">#</p>
                註：步行往港鐵站約{{ subway }}分鐘，步行時間是由系統計算出來的，當步行時間在15分鐘內，可選擇＂近港鐵＂標籤</span>
            </el-form-item>
          </el-row>
          <el-row
            v-if="propertyInfo.propertyCategory == '' || !propertyInfo.propertyCategory || propertyInfo.propertyCategory == '2'"
            :gutter="20"
            class="cate"
          >
            <el-form-item label="工商專用">
              <span class="tags_geshu">最多選擇3個</span>
              <el-checkbox-group
                v-model="tagsBus"
                :max="3"
                class="moreChoose"
                :disabled="propertyInfo.propertyCategory == '' || !propertyInfo.propertyCategory"
                @change="changeTags(tagsBus,4)"
              >
                <el-checkbox
                  v-for="citem in diConfig.ChildrenTag[4]"
                  :key="citem.dictionaryValue"
                  :label="citem.dictionaryValue"
                >
                  {{ citem.dictionaryNameWithCulture }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-row>
          <el-row
            v-if="propertyInfo.propertyCategory == '' || !propertyInfo.propertyCategory || propertyInfo.propertyCategory == '4'"
            :gutter="20"
            class="cate"
          >
            <el-form-item label="配套(車位專用)">
              <span class="tags_geshu">最多選擇6個</span>
              <el-checkbox-group
                v-model="tagsPark"
                :max="6"
                class="moreChoose charBox"
                :disabled="propertyInfo.propertyCategory == '' || !propertyInfo.propertyCategory"
                @change="changeTags(tagsPark,5)"
              >
                <el-checkbox
                  v-for="citem in diConfig.ChildrenTag[5]"
                  :key="citem.dictionaryValue"
                  :disabled="citem.dictionaryValue == 51 && subway > 15"
                  :label="citem.dictionaryValue"
                >
                  <p
                    v-if="citem.dictionaryValue == 51"
                    style="color: red; display: inline-block"
                  >
                    #
                  </p>
                  {{ citem.dictionaryNameWithCulture }}
                </el-checkbox>
                <span
                  v-if="propertyInfo.propertyCategory == '4' && addressSearch && subway != -1 && Object.keys(EstateInfo).length"
                  class="tags_subpark"
                ><p style="color: red; display: inline-block">#</p>
                  註：步行往港鐵站約{{ subway }}分鐘，步行時間是由系統計算出來的，當步行時間在15分鐘內，可選擇＂近港鐵＂標籤</span>
              </el-checkbox-group>
            </el-form-item>
          </el-row>
          <div :class="['link-top',propertyInfo.propertyCategory == '4'?'link-topPark':'']" />
          <div class="tag_tit">
            <div class="tag_red">
              <span>已選標籤</span>
              <span class="tag_gra">按住可拖動標籤調整順序，列表與詳情頁根據順序顯示</span>
            </div>
          </div>
          <div class="tag_box">
            <draggable
              v-model="selectedTags"
              chosen-class="chosen"
              :disabled="draggableStart"
              @end="tagEnd"
            >
              <transition-group>
                <div
                  v-for="(item, index) in selectedTags"
                  :key="index"
                  class="tags_warp"
                >
                  <span
                    :class="['el-tags']"
                    v-text="item.val"
                  />
                </div>
              </transition-group>
            </draggable>
          </div>
        </div>
      </div>
      <!-- 上傳樓盤圖片 -->
      <div
        v-if="!conditions || searchRes"
        ref="images"
        class="pic"
      >
        <div class="pic_tit">
          <h3 :class="{ red: images.length < 3 && propertyInfo.topType == 3 && $route.query.gradeRule == 'starValidate'}">
            {{ conditions ? '選擇' : '上傳' }}樓盤圖片
          </h3>
          <!-- <span class="tip">如現在沒有照片，可以在修改樓盤時加回。</span> -->
        </div>
        <div class="content">
          <!-- 左侧文字描述 -->
          <div class="desc">
            <h4>圖片</h4>
            <p class="text">
              <!-- <span>第一張是封面圖</span> -->
              <span>你已{{ conditions ? '選擇' : '上載' }}圖片{{ images.length }}</span>
              <span>你還可以{{ conditions ? '選擇' : '上載' }}圖片{{ 40 - images.length }}</span>
              <span 
                v-if="defaultImgTip" 
                class="red"
              >
                請選擇一張圖片為封面圖
              </span>
            </p>
          </div>
          <div
            v-if="mode != '1'"
            class="qrCode"
          >
            <div
              ref="qrCodeDiv"
              class="code"
            />
            <div
              v-if="!isinit"
              class="maskcode"
            />
            <div class="recode">
              <p>使用手機掃瞄QR Code，<br>可即時從手機上傳圖片</p>
              <div
                class="lickcode"
                @click="initQr"
              >
                請點擊更新顯示QR Code
              </div>
              <div class="quick_up">
                建議首次掃描後儘快上傳圖片
              </div>
            </div>
            <!-- <p>使用手機掃瞄QR Code，<br />可即時從手機上傳圖片</p> -->
          </div>
          <!-- 按钮 -->
          <div :class="{ btnLine: true, zybtnLine: conditions }">
            <div class="starPicTips">
              <div
                class="imgstar red"
              >
                建議上傳圖片為16:9橫圖格式
              </div>
              <div>
                <span
                  v-if="isUseStandard"
                  class="imgstar"
                >標準盤</span>
                <span
                  v-if="isUseSuper"
                  class="imgstar"
                >{{ isUseStandard ? '/' : '' }}精選盤</span>
                <span
                  v-if="isUseSuper || isUseStandard"
                  class="imgstar"
                > - 上載至少1張樓盤圖片</span>
              </div>
              <div
                v-if="isUseStar"
                :class="{imgstar:true, red:images.length < 3 && propertyInfo.topType == 3 && $route.query.gradeRule == 'starValidate'}"
              >
                星級盤 - 上載至少3張樓盤圖片
              </div>
              <span
                v-if="isUseStar"
                class="imgstar"
              > - 圖片尺寸16:9，建議上載圖片為16:9橫圖格式</span>
              <div 
                class="aibtn_box" 
              >
                <el-button
                  v-if="isAIRetouchImage"
                  type="primary"
                  :class="['chooseBtn',images.length < 1 ? 'disabled_btn' : '']"
                  plain
                  :disabled="images.length < 1 || galleryLoading"
                  @click="generateAiImg()"
                >
                  <i 
                    v-show="isMinimized && (fabtnLoading || isTagAnalyzing || galleryLoading)"
                    class="el-icon-loading"
                  />
                  AI執相
                </el-button>
                <el-button
                  v-if="(mode == 'post' && isAIRetouchImage) || (mode != 'post' && (aiResultsCount || isAIRetouchImage)) "
                  type="primary"
                  :class="['chooseBtn',images.length < 1 ? 'disabled_btn' : '']"
                  plain
                  :disabled="images.length < 1 "
                  @click="showAiGallery()"
                >
                  AI圖庫
                </el-button>
              </div>
            </div>
            <!-- 上傳我的圖片-->
            <el-button
              v-if="conditions"
              type="primary"
              plain
              class="chooseBtn right_10"
              @click="selectImgShow = true"
            >
              選擇公司圖片
            </el-button>
            <el-upload
              class="avatar-uploader"
              :http-request="upimg"
              action="#"
              accept="image/jpeg,image/jpg,image/png"
              :file-list="file"
              :show-file-list="false"
              :on-exceed="handleExceed"
              :limit="40"
              multiple
              :before-upload="beforeUpload"
            >
              <el-button
                v-if="conditions"
                type="primary"
                plain
                class="chooseBtn"
              >
                上傳我的圖片
              </el-button>
              <el-button
                v-else
                type="primary"
                plain
                class="chooseBtn"
              >
                選擇文件
              </el-button>
            </el-upload>
            <div class="c_button">
              <el-button
                type="primary"
                class="fo_btn"
                plain
                :disabled="images.length == 0"
                @click="selAllImg"
              >
                <svg
                  class="icon"
                  aria-hidden="true"
                >
                  <use xlink:href="#iconquanxuan" />
                </svg>
                全選
              </el-button>
              <el-button
                type="primary"
                plain
                :disabled="selectedImage.length === 0 || fabtnLoading || isTagSelecting"
                @click="rotate(270)"
              >
                <svg
                  class="icon"
                  aria-hidden="true"
                >
                  <use xlink:href="#iconzuoxuanzhuan" />
                </svg>
                旋轉
              </el-button>
              <!--  rotate(selectedImage[0], images[selectedImage[0]].imagePath, 90)  :disabled="selectedImage.length === 0 || selectedImage.length > 1-->
              <el-button
                type="primary"
                plain
                :disabled="selectedImage.length === 0 || fabtnLoading || isTagSelecting"
                @click="rotate(90)"
              >
                <svg
                  class="icon"
                  aria-hidden="true"
                >
                  <use xlink:href="#iconyouxuanzhuan" />
                </svg>
                旋轉
              </el-button>
              <el-button
                type="primary"
                plain
                :disabled="selectedImage.length === 0 || fabtnLoading || isTagSelecting"
                @click="delPic()"
              >
                <svg
                  class="icon"
                  aria-hidden="true"
                >
                  <use xlink:href="#iconshanchu" />
                </svg>
                删除
              </el-button>
              <el-button
                type="primary"
                :disabled="selectedImage.length === 0 || selectedImage.length > 1 || fabtnLoading || isTagSelecting"
                plain
                @click="editPic( images[selectedImage[0]].imagePath)"
              >
                <svg
                  class="icon"
                  aria-hidden="true"
                >
                  <use xlink:href="#iconbianjitupian" />
                </svg>
                編輯
              </el-button>
              <el-button
                type="primary"
                plain
                :disabled="selectedImage.length === 0 || selectedImage.length > 1"
                @click="largeImg"
              >
                <i class="el-icon-zoom-in" /> 放大
              </el-button>
            </div>
          </div>
          <!-- 图片 -->
          <div class="image">
            <draggable
              v-model="images"
              :disabled="draggableStart"
              @update="dragUpdate"
            >
              <transition-group>
                <div
                  v-for="(item, index) in images"
                  :key="index"
                  class="img_warp"
                >
                  <div
                    class="el-image"
                    :class="{ selected: selectedImage.includes(index) }"
                    @click="selected(index)"
                  >
                    <img
                      :src="item.localPath || item.imagePath + '?x-oss-process=style/300xauto_f'"
                      alt
                      width="180"
                      height="135"
                    >
                    <span
                      v-if="item.status === 'uploading'"
                      class="up-loading "
                    >
                      <span class="loadingimg">圖片上傳中<i class="el-icon-loading" /></span>
                    </span>
                    <span
                      v-else-if="item.status === 'queue'"
                      class="up-loading"
                    >等待上傳</span>
                    <span
                      v-else-if="item.status === 'retrying'"
                      class="up-loading"
                    >第{{ item.retryCount }}次重傳嘗試中</span>
                    <span
                      v-else-if="item.status === 'fail'"
                      class="up-loading"
                    >
                      <span v-if="item.changeFailText">等待上傳</span>
                      <span v-else>上傳失敗<br>請刪除</span>
                    </span>
                    <span
                      v-else-if="item.status === 'rotateing'"
                      class="up-loading"
                    >
                      旋轉中
                    </span>
                    <span v-else>加載失敗</span>
                    <!-- <span v-if="item.localPath && !item.imagePath" class="up-loading">{{ curQueue.file.localPath == item.localPath ? '上傳中' : '列隊中' }}</span>
                                        <span v-else-if="!item.localPath && !item.imagePath" class="up-loading">
                                            上傳失敗
                                            <br />請刪除
                                        </span> -->
                  </div>
                  <svg
                    class="icon icon_left"
                    aria-hidden="true"
                    @click="goTop(index, item)"
                  >
                    <use xlink:href="#iconxia" />
                  </svg>
                  <svg
                    class="icon icon_right"
                    aria-hidden="true"
                    @click="goNext(index, item)"
                  >
                    <use xlink:href="#iconxia" />
                  </svg>
                  <svg
                    v-if="item.imagePath"
                    :class="['icon','icon_right_top', selectedImage.includes(index) ? 'right_top_3':'']"
                    aria-hidden="true"
                    @click="delCurPic(index, item)"
                  >
                    <use xlink:href="#iconguanbi-copy" />
                  </svg>
                  <div :class="['icon','icon_bottom', selectedImage.includes(index) ? 'bottom_3':'']">
                    <el-checkbox
                      v-model="item.isDefault"
                      @change="changeDefaultImg(index)"
                    >
                      設爲封面圖
                    </el-checkbox>
                  </div>
                  <div 
                    v-if="item.isHaveAIImage"
                    :class="['icon_right_bottom',selectedImage.includes(index) ? 'bottom_right':'']"
                  >
                    <div class="bottom_ai">
                      <!--  && !item.isUsedAIImage -->
                      {{ item.aiImageUrl ? 'AI圖': item.isHaveAIImage ? '原圖' : ''}}
                    </div>
                  </div>
                  <el-select
                    v-model="item.imageType"
                    placeholder="圖片位置"
                    no-data-text="暫無數據"
                  >
                    <el-option
                      v-for="item in diConfig.PropertyImageType"
                      :key="item.dictionaryValue"
                      :label="item.dictionaryNameWithCulture"
                      :value="item.dictionaryValue"
                      @click.native="pushCache"
                    />
                  </el-select>
                  <el-input
                    v-model="item.imageDesc"
                    placeholder="圖片描述"
                    maxlength="50"
                    class="descWidth"
                    type="textarea"
                    :autosize="{ minRows: 3, maxRows: 3 }"
                    @blur="pushCache"
                  />
                </div>
              </transition-group>
            </draggable>
          </div>
        </div>
      </div>

      <!-- 樓盤视频 -->
      <div
        v-if="!conditions || searchRes"
        class="video"
      >
        <div class="vd_tit">
          <h3>樓盤影片</h3>
          <span class="ques">請輸入YouTube或Facebook網站的影片連結</span>
        </div>
        <div class="content">
          <el-row :gutter="30">
            <el-form-item label="影片封面">
              <el-col
                :span="5"
                class="uploadvideo"
              >
                <!-- :file-list="videos" -->
                <el-upload
                  action="#"
                  accept="image/jpeg,image/gif,image/png"
                  :show-file-list="false"
                  :http-request="upvideoImage"
                >
                  <el-button
                    size="small"
                    :type="buttonup"
                    @click="upcol()"
                  >
                    上傳圖片
                  </el-button>
                </el-upload>
                <el-button
                  size="small"
                  :type="buttondel"
                  class="delbtn"
                  @click="delVideoImage"
                >
                  刪除
                </el-button>
              </el-col>
            </el-form-item>
          </el-row>
          <div
            v-if="videos !== null"
            class="el_upload"
          >
            <!-- <i class="el-icon-close" v-if="!isHidden"  @click="delVideoImage"></i> -->
            <img
              v-if="isHidden"
              src="./../../../assets/PMS_vid .png"
            >
            <div
              v-else-if="videos[0].defaultImagePath == ''"
              class="vid_text"
            >
              圖片正在上傳中
            </div>
            <div
              v-else-if="videos[0].defaultImagePath == '...'"
              class="vid_text"
            >
              圖片上傳失敗
            </div>
            <img
              v-else
              class="v_img"
              :src="videos[0].defaultImagePath + '?x-oss-process=style/300xauto_f'"
            >
          </div>

          <el-row :gutter="20">
            <div
              v-if="isFirst"
              class="vidput"
            >
              <div class="vidputs">
                <span>影片連結</span>
                <input
                  type="text"
                  placeholder="請輸入影片連結"
                >
              </div>
            </div>
            <el-form-item
              v-if="videos !== null && !isFirst"
              label="影片連結"
              prop="videoVal"
            >
              <el-input
                v-model="videos[0].videoPath"
                class="w500"
                placeholder="請輸入影片連結"
                @input="videoLink($event)"
              />
            </el-form-item>
          </el-row>
        </div>
      </div>
      <template v-if="(!conditions || searchRes) && (isaddVR || InputVR)">
        <div class="vrHide">
          <div class="vrTitle">
            <h3>樓盤VR</h3>
            <!-- <span class="ques">如需要加入VR，物業編號必須正確</span> -->
          </div>
          <div class="content">
            <el-row
              v-if="isaddVR"
              :gutter="20"
              style="height: auto"
            >
              <!-- <span class="spanHidevr">&nbsp;</span> -->
              <span class="spanHidevr">綁定樓盤VR</span>
              <el-checkbox
                v-model="propertyInfo.addVR"
                class="textHide"
              />
              <span style="font-size: 16px">&nbsp;&nbsp;有VR&nbsp;&nbsp;&nbsp;</span>
              <div class="titbox">
                <span class="vrWarn">加入VR須輸入正確物業編號，因系統處理需時，完成後會在PMS730內通知<br></span>
                <span class="vrWarn">如數天後仍未加入，請WhatsApp到 5726 6308 與客戶服務聯絡</span>
              </div>
            </el-row>
            <el-row
              v-if="InputVR"
              class="inputVr"
              :gutter="20"
            >
              <el-form-item
                prop="vrVal"
                label=""
              >
                <span class="inputVr-label">VR連結</span>
                <el-tooltip
                  popper-class="ye-vr"
                  placement="top"
                >
                  <div slot="content">
                    <p
                      class="ye-vrtext"
                      style="color: #e1c999; font-size: 14px"
                    >
                      支援的VR連結格式如下：
                    </p>
                    <p
                      v-for="(item, index) in vrRules[0].urlPrefix"
                      :key="index"
                    >
                      {{ item }}
                    </p>
                  </div>
                  <img
                    class="imgTip"
                    src="../../../assets/hovertip.svg"
                    alt=""
                  >
                </el-tooltip>
                <el-input
                  v-model="propertyInfo.inputVRURL"
                  class="w500"
                  placeholder="請輸入VR連結"
                />
              </el-form-item>
            </el-row>
          </div>
        </div>
      </template>
      <!-- 星级盘显示隐藏 -->
      <!-- <template v-if="(!conditions || searchRes) && isUseHideAgent">
                <div class="ageHide">
                    <div class="ageTitle">
                        <h3>代理公司資料</h3>
                    </div>
                    <div class="content">
                        <el-row :gutter="20">
                            <span class="spanHide">&nbsp;</span>
                            <el-checkbox v-model="propertyInfo.isHideAgent" class="textHide"></el-checkbox>
                            <span style="font-size: 16px">&nbsp;&nbsp;隱藏</span>
                            <span class="hideques">&nbsp;&nbsp;只會顯示代理聯絡電話，代理牌照，不會顯示公司名稱，地址，公司電話，公司牌照及公司標誌</span>
                        </el-row>
                    </div>
                </div>
            </template> -->
      <!-- 代理人选择 -->
      <template v-if="!conditions || searchRes">
        <div
          v-for="(item, index) in propertyUserInfo"
          :key="index"
          class="proxy"
        >
          <div class="title">
            <h3>代理人</h3>
            <span
              v-show="isEmpty_agent || draftlen"
              class="el-form-item__error"
            >必須揀選一位代理人</span>
            <span
              v-show="isdis_agent && item.userStatus == 'Disable'"
              class="el-form-item__error"
            >請選擇其他代理人</span>
          </div>
          <div class="content">
            <el-row :gutter="20">
              <el-form-item label="代理人">
                <el-select
                  v-model="agent[index]"
                  placeholder="請選擇代理人"
                  class="choose"
                  no-data-text="暫無數據"
                  @change="setAgent(index, agent[index])"
                >
                  <el-option
                    v-for="(agentItem, index) in diConfig.agentList"
                    :key="index"
                    :label="agentItem.name"
                    :value="agentItem.accountID"
                    :disabled="agent.includes(agentItem.accountID) || centaline"
                  />
                </el-select>
                <!-- 中原账户只能选择一个代理人 所以此处不展示 + 号-->
                <span class="icons">
                  <svg
                    v-show="index !== 2 && companyCategory != 1"
                    class="icon icon_add"
                    aria-hidden="true"
                    @click="addProxy(index)"
                  >
                    <use xlink:href="#iconjia" />
                  </svg>
                  <svg
                    v-show="index !== 0"
                    class="icon icon_delete"
                    aria-hidden="true"
                    @click="delProxy(index)"
                  >
                    <use xlink:href="#iconjian" />
                  </svg>
                </span>
              </el-form-item>
            </el-row>
            <el-row :gutter="20">
              <el-form-item label="電話">
                <el-col :span="5">
                  <el-input
                    v-model="item.telephone"
                    class="w320"
                    disabled
                  />
                </el-col>
              </el-form-item>
            </el-row>
            <el-row
              v-if="!isUpdateCompany && !isUseHideAgent"
              :gutter="20"
            >
              <el-form-item label="分行電話">
                <el-col :span="20">
                  <el-input
                    :class="['right_10','w320']"
                    disabled
                    :value="item.companyTel"
                  />
                  <el-checkbox
                    v-if="isShowTelephoneBtn"
                    v-model="item.isShowPmsCompanyTel"
                    @click.native.prevent="specialServe(item.isShowPmsCompanyTel,'isShowPmsCompanyTel', index)"
                  >
                    顯示
                  </el-checkbox>
                </el-col>
              </el-form-item>
            </el-row>
            <el-row :gutter="20">
              <el-form-item label="個人地產代理牌照">
                <el-col :span="5">
                  <el-input
                    v-model="item.license"
                    class="w320"
                    disabled
                  />
                </el-col>
              </el-form-item>
            </el-row>
            <el-row :gutter="20">
              <el-col
                :span="3"
                class="text_right serve"
              >
                <span>代理個人署名<br>或特別服務</span>
              </el-col>
              <el-col :span="17">
                <el-input
                  class="w320 right_10"
                  disabled
                  :value="item.isJoinAgentIntroduce ? item.signature : ''"
                />
                <el-checkbox
                  v-model="item.isJoinAgentIntroduce"
                  @click.native.prevent="specialServe(item.isJoinAgentIntroduce,'isJoinAgentIntroduce', index)"
                >
                  顯示
                </el-checkbox>
              </el-col>
            </el-row>
            <el-row
              v-if="isUseHideAgent"
              :gutter="20"
            >
              <div class="hidecom">
                <el-checkbox
                  v-model="item.isHideCompanyInfo"
                  @click.native.prevent="specialServe(item.isHideCompanyInfo,'isHideCompanyInfo', index)"
                />
                <span class="hidespan">隱藏公司資料</span>
                <span class="hidetip">只會顯示代理聯絡電話，代理牌照，不會顯示公司名稱，地址，公司電話，公司牌照</span>
              </div>
            </el-row>
            <template v-if="!item.isHideCompanyInfo">
              <el-row
                v-if="isUpdateCompany"
                :gutter="20"
              >
                <span class="agentcom">代理人公司資料</span>
                <span class="agentcomcheck">
                  <el-checkbox
                    v-model="item.isUpdateCompanyInfo"
                    @click.native.prevent="specialServe(item.isUpdateCompanyInfo,'isUpdateCompanyInfo', index)"
                  />
                  <span class="editcom">修改公司資料</span>
                  <span class="editcomtip">&nbsp;&nbsp;修改後的資料，只會保存在此樓盤，其他樓盤會按照原本系統資料顯示</span>
                </span>
              </el-row>
              <template v-if="isUpdateCompany || isUseHideAgent">
                <el-row :gutter="20">
                  <!-- <span class="red redstar_one">*</span> -->
                  <el-form-item label="公司名稱">
                    <!-- :class="['w320',item.isUpdateCompanyInfo && !propertyUserInfo[index].companyNameCN?'red_bor':'']" -->
                    <el-input
                      v-model="item.companyNameCN"
                      :disabled="!item.isUpdateCompanyInfo || !isUpdateCompany"
                      class="w320"
                      show-word-limit
                      maxlength="40"
                      @input="$forceUpdate()"
                    />
                    <span
                      v-show="!item.isUpdateCompanyInfo || !isUpdateCompany"
                      class="limitword limitword_lefto"
                    >{{ item.companyNameCN ? item.companyNameCN.length :0 }}/40</span>
                    <span class="left_40">公司名稱(英)</span>
                    <el-input
                      v-model="item.companyNameEN"
                      class="w320"
                      :disabled="!item.isUpdateCompanyInfo || !isUpdateCompany"
                      show-word-limit
                      maxlength="60"
                      @input="$forceUpdate()"
                    />
                    <span
                      v-show="!item.isUpdateCompanyInfo || !isUpdateCompany"
                      class="limitword limitword_rigo"
                    >{{ item.companyNameEN ? item.companyNameEN.length :0 }}/60</span>
                    <!-- <div class="red_tip" v-show="item.isUpdateCompanyInfo && !propertyUserInfo[index].companyNameCN">請填寫公司名稱</div> -->
                  </el-form-item>
                </el-row>
                <el-row :gutter="20">
                  <el-form-item label="公司牌照號碼">
                    <el-input
                      v-model="item.companyLicenceNumber"
                      class="w320"
                      :disabled="!item.isUpdateCompanyInfo || !isUpdateCompany"
                      show-word-limit
                      maxlength="30"
                      @input="$forceUpdate()"
                    />
                    <span
                      v-show="!item.isUpdateCompanyInfo || !isUpdateCompany"
                      class="limitword limitword_lefto"
                    >{{ item.companyLicenceNumber ? item.companyLicenceNumber.length :0 }}/30</span>
                    <!-- <div class="red_tip" v-show="item.isUpdateCompanyInfo && !propertyUserInfo[index].companyLicenceNumber">請填寫公司牌照號碼</div> -->
                  </el-form-item>
                </el-row>
                <el-row :gutter="20">
                  <el-form-item label="公司地址">
                    <el-input
                      v-model="item.companyAddress"
                      class="w320"
                      :disabled="!item.isUpdateCompanyInfo || !isUpdateCompany"
                      show-word-limit
                      maxlength="100"
                      @input="$forceUpdate()"
                    />
                    <span
                      v-show="!item.isUpdateCompanyInfo || !isUpdateCompany"
                      class="limitword limitword_lefto"
                    >{{ item.companyAddress ? item.companyAddress.length :0 }}/100</span>
                    <span class="left_40">公司地址(英)</span>
                    <el-input
                      v-model="item.companyAddressEN"
                      class="w320"
                      :disabled="!item.isUpdateCompanyInfo || !isUpdateCompany"
                      show-word-limit
                      maxlength="100"
                      @input="$forceUpdate()"
                    />
                    <span
                      v-show="!item.isUpdateCompanyInfo || !isUpdateCompany"
                      class="limitword limitword_rigo"
                    >{{ item.companyAddressEN ? item.companyAddressEN.length :0 }}/100</span>
                  </el-form-item>
                </el-row>
                <el-row :gutter="20">
                  <el-form-item label="分行電話">
                    <el-input
                      v-model="item.companyTel"
                      class="w320 right_10"
                      :disabled="!item.isUpdateCompanyInfo || !isUpdateCompany"
                      @input="inputlicenceNum(item.companyTel,'companyTel',index)"
                    />
                    <el-checkbox
                      v-if="isShowTelephoneBtn"
                      v-model="item.isShowPmsCompanyTel"
                      @click.native.prevent="specialServe(item.isShowPmsCompanyTel,'isShowPmsCompanyTel', index)"
                    >
                      顯示
                    </el-checkbox>
                  </el-form-item>
                </el-row>
              </template>
            </template>
          </div>
          <!-- </el-form-item> -->
        </div>
      </template>
      <!-- 備註 -->
      <div
        v-if="!conditions || searchRes"
        class="proRemark"
      >
        <div class="postWay_tit">
          <h3 id="remarks">
            備註
          </h3>
        </div>
        <div class="content">
          <div style="margin-left: 122px">
            <span class="beizhu">備註</span>
            <el-input
              v-model="propertyInfo.propertyRemark"
              class="textinput"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 4 }"
              maxlength="100"
            />
            <span class="zishu">最多100字</span>
            <span class="ques">不會公開</span>
          </div>
        </div>
      </div>
      <div
        v-show="isUseInstantEstateVolume && isShowChart && mode != 'edit'"
        class="proRemark chartBox"
      >
        <div class="postWay_tit">
          <h3 id="remarks">
            同戶型即時盤量資訊
          </h3>
        </div>
        <div class="content">
          <div class="chartOne_tit">
            <div class="chart_tipbox">
              <div class="chart_count">
                同區盤量分佈
              </div>
              <div class="chart_tip">
                *以下圖表數據包含標準、精選、星級盤，數據僅供參考
              </div>
            </div>
            <div class="fake_legend">
              <div class="f_legend">
                <span class="c_legend" />其他樓盤價位
              </div>
              <div class="f_legend">
                <span class="c_legend uic_legend" />你的樓盤價位
              </div>
            </div>
            <span class="chartspan chartspan_one">{{ chartOne.minValue }}</span>
            <span
              id="myChartOne"
              class="chartOne"
              :style="{ width: '435px', height: '200px',display:'inline-block' }"
            />
            <span class="chartspan chartspan_two">{{ chartOne.maxValue }}</span>
            <div class="backTitone">
              <div class="chart_count">
                平均{{ propertyInfo.rentalType == '1' ? '售' : '租' }}價 : {{ chartOne.avgVal }}
              </div>
              <div class="chart_count">
                同區競爭盤量 : {{ chartOne.proCompeteCount }}
              </div>
            </div>
          </div>
          <div
            v-show="chartEstateID"
            class="chartTwo_tit"
          >
            <div class="chart_tipbox">
              <div class="chart_count">
                {{ propertyInfo.estateName }}&nbsp;{{ propertyInfo.phaseWithCulture ? "-" + propertyInfo.phaseWithCulture + '&nbsp;':'' }}盤量分佈
              </div>
              <div class="chart_tip">
                *以下圖表數據包含標準、精選、星級盤，數據僅供參考
              </div>
            </div>
            <div class="fake_legend fakeT_legend">
              <div class="f_legend">
                <span class="c_legend" />其他樓盤價位
              </div>
              <div class="f_legend">
                <span class="c_legend uic_legend" />你的樓盤價位
              </div>
            </div>
            <span class="chartspan chartspan_three">{{ chartTwo.minValue }}</span>
            <span
              id="myChartTwo"
              class="chart"
              :style="{ width: '435px', height: '200px',display:'inline-block' }"
            />
            <span class="chartspan chartspan_four">{{ chartTwo.maxValue }}</span>
            <div class="backTitone backTittwo">
              <div class="chart_count">
                平均{{ propertyInfo.rentalType == '1' ? '售' : '租' }}價 : {{ chartTwo.avgVal }}
              </div>
              <div class="chart_count">
                {{ propertyInfo.estateName }}&nbsp;放盤量 : {{ chartTwo.proCompeteCount }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--放盤方式  -->
      <div
        v-if="!conditions || searchRes"
        class="postWay"
      >
        <div class="postWay_tit">
          <h3>放盤方式</h3>
          <span class="ques">如對付款或放盤有問題，歡迎致電査詢：3619-3200，星期一至五，上午9時到下午6時。</span>
        </div>
        <!-- <div class="content" v-if="!(propertyInfo.topType == 2 && mode == 'edit')">
                    <div class="">
                    </div>
                    <div class=""></div>
                    <div class=""></div>
                </div> -->
        <!-- 标准盘 精选盘修改的时候隐藏掉展示  精选盘复制的时候手动修改数据定位在标准盘上 -->
        <div
          v-if="!(propertyInfo.topType == 2 && mode == 'edit')"
          class="content"
        >
          <el-row
            v-if="(mode !== 'edit' && mode !== '1' && isUseStandard && Object.keys(diConfig.Normal).length) || ((mode === 'edit' || mode === '1')&& Object.keys(diConfig.Normal).length && propertyInfo.topType == '0')"
            :gutter="30"
          >
            <el-col
              :span="3"
              class="text_right"
            >
              <el-radio
                v-model="propertyInfo.topType"
                label="0"
                :disabled="mode === 'edit' || mode === '1' || mode === '2' || isDisableStand"
                @click.native="chooseProType('Normal')"
              >
                標準盤
              </el-radio>
            </el-col>
            <el-col
              :span="8"
              class="introd"
            >
              <span class="boxo" />
              <i
                v-if="mode !== '1'|| payOrderMoney || payOrderDia"
                class="title ititle"
              > 一般放盤：</i>
              <i
                v-if="mode !== '1' || !orderInfo.length"
                class="price"
              >
                <i
                  v-if="(propertyInfo.rentalType == '1' && diConfig.Normal.enableCoinSalePrice) || (propertyInfo.rentalType == '2' && diConfig.Normal.enableCoinRentPrice)"
                  class="title"
                >
                  {{ propertyInfo.rentalType == '1' ? diConfig.Normal.coinSalePrice : diConfig.Normal.coinRentPrice }}金幣&nbsp;
                </i>
                <i
                  v-if="(propertyInfo.rentalType == '1' && diConfig.Normal.enableDiamondSalePrice) || (propertyInfo.rentalType == '2' && diConfig.Normal.enableDiamondRentPrice)"
                  class="title"
                >
                  {{ propertyInfo.rentalType == '1' ? diConfig.Normal.diamondSalePrice : diConfig.Normal.diamondRentPrice }}鑽石
                </i>
              </i>
              <i
                v-if="mode === '1'"
                class="price"
              >
                <i
                  v-if="payOrderMoney"
                  class="title"
                >
                  {{ payOrderMoney }}金幣
                </i>
                <i
                  v-if="payOrderDia"
                  class="title"
                >
                  {{ payOrderDia }}鑽石
                </i>
              </i>
            </el-col>
            <el-col
              v-if="mode !== '1'"
              :span="6"
            >
              有效期：售盤{{ diConfig.Normal.effectiveDays }}天 / 租盤{{ diConfig.Normal.rentEffectiveDays }}天
            </el-col>
          </el-row>
          <!--可以放精选盘了又,利用isUseSuper.替换isUsedDiamond || propertyInfo.topType == '3' //利嘉阁和中原 不能放精选盘   废弃字段v-if="!isProhibitPublishGoldTop"-->
          <el-row
            v-if="(mode !== 'edit' && mode !== '1' && isUseSuper && Object.keys(diConfig.GoldTop).length) || ((mode === 'edit' || mode === '1')&& Object.keys(diConfig.GoldTop).length && propertyInfo.topType == '1')"
            :gutter="30"
          >
            <el-col
              :span="3"
              class="text_right"
            >
              <el-radio
                v-model="propertyInfo.topType"
                label="1"
                :disabled="mode === 'edit' || mode === '1' || mode === '2' || isDisableSuper"
                @click.native="chooseProType('GoldTop')"
              >
                精選盤
              </el-radio>
            </el-col>
            <el-col
              :span="8"
              class="introd"
            >
              <span class="boxt" />
              <i
                v-if="mode !== '1' || payOrderMoney || payOrderDia"
                class="title ititle"
              >比標準盤更有效曝光：</i>
              <i
                v-if="mode !== '1' || !orderInfo.length"
                class="price"
              >
                <i
                  v-if="(propertyInfo.rentalType == '1' && diConfig.GoldTop.enableCoinSalePrice) || (propertyInfo.rentalType == '2' && diConfig.GoldTop.enableCoinRentPrice)"
                  class="title"
                >
                  {{ propertyInfo.rentalType == '1' ? diConfig.GoldTop.coinSalePrice : diConfig.GoldTop.coinRentPrice }}金幣&nbsp;
                </i>
                <i
                  v-if="(propertyInfo.rentalType == '1' && diConfig.GoldTop.enableDiamondSalePrice) || (propertyInfo.rentalType == '2' && diConfig.GoldTop.enableDiamondRentPrice)"
                  class="title"
                >
                  {{ propertyInfo.rentalType == '1' ? diConfig.GoldTop.diamondSalePrice: diConfig.GoldTop.diamondRentPrice }}鑽石
                </i>
              </i>
              <i
                v-if="mode === '1'"
                class="price"
              >
                <i
                  v-if="payOrderMoney"
                  class="title"
                >
                  {{ payOrderMoney }}金幣
                </i>
                <i
                  v-if="payOrderDia"
                  class="title"
                >
                  {{ payOrderDia }}鑽石
                </i>
              </i>
            </el-col>
            <el-col
              v-if="mode !== '1'"
              :span="6"
            >
              有效期：售盤{{ diConfig.GoldTop.effectiveDays }}天 / 租盤{{ diConfig.GoldTop.rentEffectiveDays }}天
            </el-col>
          </el-row>
          <!-- 星級盤  -->
          <el-row
            v-if="(mode !== 'edit' && mode !== '1' && isUseStar && diConfig.Star) || ((mode === 'edit' || mode === '1') && diConfig.Star && propertyInfo.topType == '3')"
            :gutter="30"
          >
            <el-col
              :span="3"
              class="text_right"
            >
              <el-radio
                v-model="propertyInfo.topType"
                label="3"
                :disabled="mode === 'edit' || mode === '1' || mode === '2' || isDisableStar"
                @click.native="chooseProType('Star')"
              >
                星級盤
              </el-radio>
            </el-col>
            <el-col
              :span="8"
              class="introd"
            >
              <!-- 兼容奇怪楼盘 立即付款时 订单未关闭但却无金币钻石情况 -->
              <i
                v-if="mode !== '1'|| payOrderMoney || payOrderDia"
                class="title ititle"
              >比精選盤及標準盤有較高曝光機會：</i>
              <i
                v-if="mode !== '1' || !orderInfo.length"
                class="price"
              >
                <i
                  v-if="(propertyInfo.rentalType == '1' && diConfig.Star.enableCoinSalePrice) || (propertyInfo.rentalType == '2' && diConfig.Star.enableCoinRentPrice)"
                  class="title"
                >
                  {{ propertyInfo.rentalType == '1' ? diConfig.Star.coinSalePrice : diConfig.Star.coinRentPrice }}金幣&nbsp;
                </i>
                <i
                  v-if="(propertyInfo.rentalType == '1' && diConfig.Star.enableDiamondSalePrice) || (propertyInfo.rentalType == '2' && diConfig.Star.enableDiamondRentPrice)"
                  class="title"
                >
                  {{ propertyInfo.rentalType == '1' ? diConfig.Star.diamondSalePrice : diConfig.Star.diamondRentPrice }}鑽石
                </i>
              </i>
              <!-- 立即付款 且订单未关闭 存在数据 展示-->
              <i
                v-if="mode === '1' && orderInfo.length"
                class="price"
              >
                <i
                  v-if="payOrderMoney"
                  class="title"
                >
                  {{ payOrderMoney }}金幣
                </i>
                <i
                  v-if="payOrderDia"
                  class="title"
                >
                  {{ payOrderDia }}鑽石
                </i>
              </i>
            </el-col>
            <el-col
              v-if="mode !== '1'"
              :span="6"
            >
              有效期：售盤{{ diConfig.Star.effectiveDays }}天 / 租盤{{ diConfig.Star.rentEffectiveDays }}天
            </el-col>
          </el-row>
          <div
            v-show="( mode == 'post' || mode=='copy') && (isShowAutoRec || (isShowAutoRecCount > 1 && isShowHighTop))"
            class="recBox"
          >
            <div class="c_recBox">
              <span class="red">*</span>
              可考慮
              <span
                v-if="isShowAutoRecCount > 1 && (mode =='post' || mode == 'copy') && isShowHighTop"
                class="red"
              >升級放盤方式</span>
              <span v-if="isShowAutoRec && isShowAutoRecCount > 1 && (mode =='post' || mode == 'copy') && isShowHighTop">或</span>
              <span
                v-if="isShowAutoRec"
                class="red"
              >自動置頂</span>
              提升樓盤曝光度
            </div>
            <div
              v-if="isShowAutoRec"
              class="recCheckbox"
            >
              <el-checkbox
                v-model="propertyInfo.isAutoRecommend"
                @change="clearRecSetID"
              />
              <span>&nbsp;&nbsp;自動置頂</span>
              <span v-if="propertyInfo.isAutoRecommend">
                <span v-if="autoRecommendList && autoRecommendList.length == 1">
                  {{ autoRecommendList[0].recommendNumber }}天/{{ autoRecommendList[0].price }}鑽石&nbsp;&nbsp;此服務為單次付款，付款後立即生效。
                </span>
                <span v-if="autoRecommendList && autoRecommendList.length > 1">
                  <el-form-item
                    prop="autoRec"
                    class="recboxitem"
                  >
                    <el-select
                      v-model="propertyInfo.propertyCoinSetID"
                      class="w150 left_20"
                      placeholder="請選擇配置方案"
                    >
                      <el-option
                        v-for="item in autoRecommendList"
                        :key="item.id"
                        :label="item.priceSetCulture"
                        :value="item.id"
                        @click.native="selAutoRecOption(item)"
                      />
                    </el-select>
                    <span class="blacktip">目前提供了多個組合，請選擇您偏好的天數，此服務為單次付款，付款後立即生效。</span>
                  </el-form-item>
                </span>
              </span>
            </div>
          </div>
        </div>
        <!-- 楼盘验证 废弃 -->
        <!-- 附加（增值）選項 标准盘不允许楼盘验证 -->
        <!-- <div class="Attach" v-if="isUsedDiamond && propertyInfo.topType != 0">
                    <p class="tit">附加（增值）選項</p>
                    <div class="content_sencend">
                        <el-row :gutter="20">
                            <el-form-item label-width="0" prop="isVerify">
                                <el-col :span="3" class="text_right serve">
                                    <el-checkbox v-model="propertyInfo.isVerify" @change="Verify" :disabled="mode === 'edit' || mode === '1' || (mode === '2' && apiData.isVerify)"></el-checkbox>
                                    <span>樓盤驗證</span>
                                </el-col>
                                <el-col :span="7">樓盤詳情顯示為「已驗證」，加強買家/租戶信心</el-col>
                                <el-col :span="4" class="left_negative15">{{ diConfig.VerifyLabel.diamond }}鑽石</el-col>
                                <el-col :span="3" v-show="!(mode === '2' && apiData.isVerify) && propertyInfo.isVerify && (mode !== 'edit' ||( mode == 'edit' && showPropVerify)) && mode !== '1'"><span class="file" @click="attachVisible = true">樓盤驗證文件</span></el-col>
                            </el-form-item>
                        </el-row>
                    </div>
                </div> -->
      </div>
      <!-- 選擇支付方式 -->
      <template v-if="mode !== 'edit'">
        <div
          v-if="!conditions || searchRes"
          class="pay"
        >
          <div>
            <h2 class="payway">
              付款詳情
            </h2>
            <template v-if="isUsedCoin">
              <svg
                class="icon iconjinbi"
                aria-hidden="true"
              >
                <use xlink:href="#iconjinbi" />
              </svg>
              <span v-if="accountType && (userInfo.roleID == 1 || userInfo.roleID == 2)">
                公司賬戶持有House730金幣：<i>{{ remainderStrPropertyCoin }}</i></span>
              <span
                v-else
              >個人持有House730金幣：<i>{{ remainderStrPropertyCoin }}</i></span>
              <span
                v-if="isUsedDiamond"
                class="line"
              >/</span>
            </template>
            <template v-if="isUsedDiamond">
              <svg
                class="icon iconzuanshi"
                aria-hidden="true"
              >
                <use xlink:href="#iconzuanshi" />
              </svg>
              <span v-if="accountType && (userInfo.roleID == 1 || userInfo.roleID == 2)">
                公司賬戶持有House730鑽石：<i>{{ remainderStrDiamond }}</i></span>
              <span
                v-else
              >個人持有House730鑽石：<i>{{ remainderStrDiamond }}</i></span>
            </template>
          </div>
          <div
            v-if="isUseCoupon"
            class="coupon_con"
          >
            <span> 放盤優惠券</span>
            <el-input
              v-model.trim="propertyInfo.couponKeyword"
              :disabled="isDisCoupon"
              placeholder="請輸入優惠券活動名稱或優惠券密碼"
              class="w320"
              type="text"
              @input="$forceUpdate()"
            />
            <!-- <el-button type="primary" :disabled="isDisCoupon" :class="['coupon_btn' ,'left_10',{ disbutCoupon: isDisCoupon }]" @click="couponConInput">確定</el-button> -->
            <el-button
              v-show="!isDisCoupon"
              type="primary"
              :class="['coupon_btn' ,'btn_bgc','left_10']"
              @click="couponConInput"
            >
              確定
            </el-button>
            <el-button
              v-show="isDisCoupon"
              type="danger"
              :class="['coupon_btn' ,'left_10']"
              @click="cancelCoupon"
            >
              取消
            </el-button>
            <div class="coupon_div">
              當前放盤支援使用優惠券。<br>如有任何問題，請聯絡我們的銷售代表或客戶服務專員，謝謝。
            </div>
            <div
              v-if="isDisCouponMes"
              :class="['valTit',isCouponStatus ? '' : 'valErrTit']"
            >
              {{ isDisCouponMes }}
            </div>
          </div>
          <div
            v-if="showCoinPay && showDiamondPay"
            class="icon_diatxt"
          >
            請選擇貨幣付款
          </div>
          <div
            v-if="showCoinPay"
            :class="['iconPay',mode==='1' || payCoinDis?'payDis':'']"
            @click="changeCoin('coin')"
          >
            <div :class="['icon_img',disCoin ?'dis_coin':'cli_coin']" />
            <span class="total">{{ totalPrice }}金幣</span>
          </div>
          <div
            v-if="showDiamondPay"
            :class="['iconPay',mode==='1' || payDiaDis ?'payDis':'']"
            @click="changeCoin('diamond')"
          >
            <div :class="['icon_diamond',disDiamond ?'dis_diamond':'cli_diamond']" />
            <span class="total">{{ totaldiamond }}鑽石</span>
          </div>
          <div
            v-if="isDisCoupon && isUseCoupon"
            class="origin_price"
          >
            &nbsp;你已節省了{{ OriginalPrice }}{{ propertyInfo.paymentType == 3 ? '鑽石':'金幣' }}{{ couponEffectiveDays != 0 ? '（優惠券放盤的有效期為 '+ couponEffectiveDays +'天）' :'' }}<i class="el-icon-circle-check" />&nbsp;
          </div>
          <div
            v-if="payWayEmpy"
            class="valTit"
          >
            請選擇付款方式
          </div>
        </div>
      </template>
      <div
        v-if="propertyInfo.isAutoRecommend"
        class="payrec"
      >
        <svg
          class="icon"
          aria-hidden="true"
        >
          <use xlink:href="#iconzidongzhiding1" />
        </svg>
        自動置頂：{{ recAutoDia }}鑽石
      </div>
      <el-form-item
        v-if="!conditions || searchRes"
        label=""
        prop="agree"
        class="agree"
      >
        <el-checkbox v-model="propertyInfo.agree" />
        <span>已閱讀及同意</span><a
          href="/property/terms"
          target="view_window"
        >放盤條款</a>
      </el-form-item>
      <!-- 立即放盤 -->
      <div
        v-if="!conditions || searchRes"
        class="quickly"
      >
        <!-- <el-button type="primary" size="medium" :disabled="disablePost" @click="draft" v-if="(mode === 'post' || mode === 'copy') && !conditions">儲存草稿</el-button> -->
        <el-button
          v-if="$route.query.gradeRule == 'starValidate'"
          type="danger"
          size="medium"
          :loading="disablePost"
          @click="validation('propertyInfo')"
        >
          {{ disablePost ? '提交中' : '確認' }}
        </el-button>
        <el-button
          v-else-if="mode === 'edit'"
          type="danger"
          size="medium"
          :loading="disablePost"
          @click="validation('propertyInfo')"
        >
          {{ disablePost ? '提交中' : '提交更改' }}
        </el-button>
        <el-button
          v-if="mode === 'edit'"
          type="info"
          size="medium"
          @click="removeEdit"
        >
          取消更改
        </el-button>
        <el-button
          v-else
          type="danger"
          size="medium"
          :disabled="disPostBut"
          :class="[{ disbutgray: disPostBut }]"
          :loading="disablePost"
          @click="validation('propertyInfo')"
        >
          {{ disablePost ? '提交中' : propertyInfo.rentalType == '1' ? '立即放售盤' : '立即放租盤' }}
        </el-button>
        <div
          v-if="mode != 'edit' && (propertyInfo.estateName||propertyInfo.estateNameEn)"
          class="butBot"
        >
          已自動儲存草稿
        </div>
        <!-- <div :class="mode == '1' ? 'centerBut' : 'draftTip'" v-if="disPostBut && mode !== 'edit'">
                    <div v-if="mode !== '1'">請先儲存草稿</div>
                    <div>如需購買金幣或鑽石，請與我們的營業代表聯絡</div>
                </div> -->
      </div>
      <div
        v-show="disablePost && (mode === 'post' || mode === 'copy')"
        :class="['postTip', { zypostTip: conditions }]"
      >
        放盤提交中 請勿重新載入頁面
      </div>
    </el-form>
    <!--  附加（增值）選項 弹窗 :before-close="handleClose"   -->
    <!-- <el-dialog :before-close="quit" title="樓盤驗證" :visible.sync="attachVisible" width="45%" center class="dialog_attach">
            <p>請上傳樓盤的委託放盤證明、確實地址、業權證明及其他相關資料，或將相關資料WhatsApp到 5726 6308，我們會在3個工作天內完成審核。</p>
            <br />
            <p>如果你是業主，請提供電費單/水費單/差餉。</p>
            <br />
            <p>如果你是代理，請提供委託放盤證明及其他相關資料。</p>
            <el-upload :fileList="verifyFile" :disabled="verifyFile.length > propertyInfo.verifyImage.length" class="upload-demo" multiple action="#" accept="image/jpeg,image/jpg,image/png" :show-file-list="false" :limit="3" :http-request="upVerifyImage" :on-exceed="handleExceed" :before-upload="beforeUpload">
                <el-button size="small" type="primary" class="upBtn" :disabled="verifyFile.length > propertyInfo.verifyImage.length">上傳圖片</el-button>
                <p style="color:#e50113;font-size:12px;position:absolute" v-if="showEditerror">請上傳樓盤驗證文件</p>
            </el-upload>
            <span class="more">最多3張</span>
            <div class="verifyImg">
                <span v-for="(item, index) in propertyInfo.verifyImage" :key="item">
                    <img :src="pub.imgResize(item, 'user')" alt="" width="100" height="75" />
                    <i class="el-icon-close" @click="delVerifyImage(index)"></i>
                </span>
                <i class="red left_10" v-show="verifyFile.length > propertyInfo.verifyImage.length">圖片正在上傳中</i>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="quit">取 消</el-button>
                <el-button type="primary" @click="conVerifyImage">確 認</el-button>
            </span>
        </el-dialog> -->
    <!-- 付款提示框 -->
    <el-dialog
      class="img_up"
      title="提示"
      :visible.sync="imgwarning"
      width="30%"
      left
      :show-close="false"
    >
      <div class="icon_img_txt">
        <svg
          class="icon up_icon"
          aria-hidden="true"
        >
          <use xlink:href="#icontupianshangchuan" />
        </svg>
        <span class="mar_5">相片上傳中({{ nonSuccessCount }}/{{ images.length }})</span>
        <p class="mar_24">
          注意！仍有【{{ nonSuccessCount }}】張相未上傳
        </p>
        <p class="mar_24">
          如果現在刊登，只會顯示已上傳的【{{ images.length - nonSuccessCount }}】張相
        </p>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="imgValidation">即刻刊登</el-button>
        <el-button
          type="primary"
          @click="scrollImg"
        >等埋剩低嘅相</el-button>
      </span>
    </el-dialog>
    <el-dialog
      class="payPopup"
      title="使用House730金幣"
      :visible.sync="tip"
      width="30%"
      left
      :before-close="quitPay"
    >
      <div class="tip_text">
        <p>
          <span>放盤方式</span>:
          {{ propertyInfo.topType === '0' ? '標準盤' : propertyInfo.topType === '1' ? '精選盤' : '星級盤' }}
          {{ propertyInfo.isVerify ? '、樓盤驗證' : '' }}
        </p>
        <p><span>付款總額</span>: {{ propertyInfo.paymentType === 3 ? totaldiamond + '鑽石' : totalPrice + '金幣' }}&nbsp;{{ isDisCoupon && isUseCoupon ? '('+isDisCouponMes +')'+ '&nbsp;':'' }}{{ propertyInfo.isAutoRecommend ? '+'+recAutoDia + '鑽石' :'' }}</p>
        <p>請確認放盤資料及付款</p>
        <p
          v-if="disConfirm"
          class="red butBot"
        >
          鑽石不足，無法繼續完成樓盤刊登
        </p>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="quitPay">取 消</el-button>
        <el-button
          type="primary"
          :class="[{disbutCoupon:disConfirm}]"
          :disabled="disConfirm"
          @click="debounce(sendData(), 500)"
        >確 認</el-button>
        <!-- <el-button type="primary" @click="sendData()">確 認</el-button> -->
      </span>
    </el-dialog>

    <!-- 查看大图 -->
    <div
      v-if="enLarge"
      class="enLarge"
    >
      <span
        class="el-image-viewer__btn el-image-viewer__close"
        @click="enLarge = false"
      ><i class="el-icon-circle-close" /></span>
      <span
        class="el-image-viewer__btn el-image-viewer__prev"
        @click="changeImg('prev')"
      ><i class="el-icon-arrow-left" /></span>
      <span
        class="el-image-viewer__btn el-image-viewer__next"
        @click="changeImg('next')"
      ><i class="el-icon-arrow-right" /></span>
      <div class="el-image-viewer__canvas">
        <img
          ref="bigImg"
          :src="images[selectedImage[0]].imagePath + '?x-oss-process=style/master'"
          class="el-image-viewer__img"
        >
      </div>
    </div>
    <!-- :modal="!isMinimized"
      :lock-scroll="true"
      :modal-append-to-body="true" -->
    <el-dialog
      :visible.sync="dialogAIVisible"
      width="70%"
      :show-close="false"
      :custom-class="isMinimized ? 'ai-dialog-minimized' : 'ai-dialog-normal'"
      :modal="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      destroy-on-close
    >
      <div 
        slot="title" 
        class="dialog-header-custom"
      >
        <div 
          v-if="!isMinimized"
          class="header-tabs"
        >
          <div 
            v-if="isAIRetouchImage"
            :class="['tab-item', activeTab === 'process' ? 'is-active' :images.length === 0 || galleryLoading ? 'distab': '']" 
            @click.stop="handleTabClick"
          >
            AI 執相
          </div>
          <div 
            v-if="(mode == 'post' && isAIRetouchImage) ||  (mode != 'post' && (aiResultsCount || isAIRetouchImage)) "
            :class="['tab-item', activeTab === 'gallery' ? 'is-active' : '']" 
            @click.stop="activeTab = 'gallery'"
          >
            AI 圖庫
          </div>
        </div>

        <div
          v-else
          :class="['minimized-text', activeTab === 'gallery' ? 'is-active' : '']"
          @click.stop="isMinimized = !isMinimized"
        >
          <i 
            v-if="fabtnLoading || isTagAnalyzing || galleryLoading"
            class="el-icon-loading" 
            style="margin-left: 8px;"
          />
          <!--  @click.stop="isMinimized = !isMinimized" -->
          <span :class="[ !fabtnLoading && !isTagAnalyzing && !galleryLoading ? 'distext' : '',aiTaskStatus == 2 ? 'green': 'blue']">AI 執相</span>
        </div>
        
        <!-- :icon="isMinimized ? 'el-icon-full-screen' : 'el-icon-minus'"  -->
        <div 
          v-show="!isMinimized"
          class="header-actions" 
        >
          <!-- <el-button 
            type="text"
            icon="el-icon-minus"
            @click.stop="isMinimized = !isMinimized"
          >
            {{ isMinimized ? '' : '最小化' }}
          </el-button> -->
          <span @click.stop="changeMinimize">
            <svg
              class="icon"
              aria-hidden="true"
            >
              <use :xlink:href="isMinimized ? '#iconzuidahua':'#iconzuixiaohua'" />
            </svg>
          </span>
        </div>
      </div>

      <div 
        v-show="!isMinimized" 
        class="dialog-body-content"
      >
        <ai-photo 
          v-show="activeTab === 'process'" 
          ref="aiPhotoRef" 
          :propertyID="propertyInfo.propertyID" 
          :draftID="propertyInfo.draftID"  
          :images="images" 
          :is-minimized="isMinimized"
          :active-tab="activeTab"
          :tag-analysising.sync="isTagAnalyzing"
          :tag-selecting.sync="isTagSelecting"
          :mode="mode" 
          @close="dialogAIVisible = false" 
          @submit-success="handleSwitchToGallery" 
          @submit-analysis="handleAITaskSubmit"
        />
        <ai-gallery 
          v-show="activeTab !== 'process'" 
          :data-list="galleryData" 
          :old-data="oldGalleryData"
          :order-list="images.map(img => img.imagePath.split('?')[0])"
          :submit-result="lastSubmitResult" 
          :loading="galleryLoading"
          @confirm="handleGalleryConfirm" 
          @confirm-result-shown="handleClearResult" 
        />
      </div>
    </el-dialog>

    <!-- 中原利嘉阁选择图片弹窗 -->
    <el-dialog
      title="選擇圖片"
      :visible.sync="selectImgShow"
      width="70%"
      class="chooseImg"
      :close-on-click-modal="false"
    >
      <p v-if="getConImgae">
        圖片獲取中...
      </p>
      <ul>
        <li
          v-for="(item, index) in propertyInfo.imageExternal"
          :key="index"
        >
          <i
            v-show="selList.indexOf(item.imagePath) >= 0"
            class="seleceted base"
            @click="addSelected(item)"
          >{{ selList.indexOf(item.imagePath) + 1 }}</i>
          <i
            class="unselected base"
            @click="addSelected(item)"
          />
          <img
            :src="item.imagePath"
            alt=""
            @click="addSelected(item)"
          >
          <!-- <img :src="item.imagePath.indexOf('house730') > -1 ? `${item.imagePath}?x-oss-process=style/master` : item.imagePath" alt="" @click="addSelected(item)" /> -->
        </li>
      </ul>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <span class="tiptxt">你已選擇圖片：{{ images.length }} 還可選擇圖片：{{ 40 - images.length }}</span>
        <el-button
          type="primary"
          @click="preview"
        >
          預覽已選圖片
        </el-button>
        <el-button
          type="primary"
          @click="done"
        >
          完成 ({{ images.length }})
        </el-button>
      </div>
    </el-dialog>
    <el-image-viewer
      v-if="enLarge1"
      :on-close="closeViewer"
      class="enLarge"
      :url-list="selList"
    />

    <!-- 选择关键词对话框 :before-close="handleClose"-->
    <el-dialog
      :title="Words.dialogTitle"
      :visible.sync="commonWords"
      width="60%"
      class="commonWords"
    >
      <el-checkbox-group
        v-if="Words.flag == 1 && BusinessWords.flag == 1"
        v-model="Words.checkedTitle"
        :max="5"
      >
        <div style="margin-bottom: 10px; font-weight: 700; font-size: 20px">
          一般常用詞
        </div>
        <el-checkbox
          v-for="(item, index) in Words.title"
          :key="index"
          :label="item.chinese"
        >
          {{ item.chinese }}
        </el-checkbox>
        <div style="margin-top: 20px; margin-bottom: 10px; font-weight: 700; font-size: 20px">
          工商專用常用詞
        </div>
        <el-checkbox
          v-for="item in BusinessWords.title"
          :key="item.chinese"
          :label="item.chinese"
        >
          {{ item.chinese }}
        </el-checkbox>
      </el-checkbox-group>
      <el-checkbox-group
        v-if="Words.flag == 2 && BusinessWords.flag == 2"
        v-model="Words.checkedIntr"
        :max="10"
      >
        <div style="margin-bottom: 10px; font-weight: 700; font-size: 20px">
          一般常用詞
        </div>
        <el-checkbox
          v-for="(item, index) in Words.Introduction"
          :key="index"
          :label="item.chinese"
        >
          {{ item.chinese }}
        </el-checkbox>
        <div style="margin-top: 20px; margin-bottom: 10px; font-weight: 700; font-size: 20px">
          工商專用常用詞
        </div>
        <el-checkbox
          v-for="item in BusinessWords.Introduction"
          :key="item.chinese"
          :label="item.chinese"
        >
          {{ item.chinese }}
        </el-checkbox>
      </el-checkbox-group>
      <el-checkbox-group
        v-if="Words.flag == 3"
        v-model="Words.checkedFacSer"
        :max="10"
      >
        <div style="margin-bottom: 10px; font-weight: 700; font-size: 20px">
          設施
        </div>
        <el-checkbox
          v-for="(item, index) in Words.facilitiesWord"
          :key="index"
          :label="item.chinese"
        >
          {{ item.chinese }}
        </el-checkbox>
        <div style="margin-top: 20px; margin-bottom: 10px; font-weight: 700; font-size: 20px">
          服務
        </div>
        <el-checkbox
          v-for="item in Words.serviceWord"
          :key="item.chinese"
          :label="item.chinese"
        >
          {{ item.chinese }}
        </el-checkbox>
      </el-checkbox-group>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="wordQuit">取 消</el-button>
        <el-button
          type="primary"
          @click="confirmWord"
        >確 認</el-button>
      </span>
    </el-dialog>

    <!-- 精选盘最少上传一张 -->
    <el-dialog
      :visible.sync="showTopImage"
      width="30%"
      class="showTopImage"
    >
      <p v-if="propertyInfo.topType == 3">
        刊登星級盤要求
      </p>
      <span v-html="ruleInfo" />
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="showTopImage = false"
        >確 認</el-button>
      </span>
    </el-dialog>

    <!-- 楼盘升级弹框 -->
    <el-dialog
      top="25vh"
      :show-close="false"
      :close-on-click-modal="false"
      class="ti-shi"
      title="樓盤升級"
      width="580px"
      :visible.sync="upgradeDiaStep"
    >
      <div class="rec_jieyu">
        樓盤 {{ $route.query.propertyId }} 成功升級
      </div>
      <div class="rec_jieyu">
        放盤方式：{{ apiData.topType == '1' ? '精選盤' : '標準盤' }}→星級盤
      </div>
      <div class="rec_jieyu">
        付款金額：{{ starUpgradeObj.targetPrice }}鑽石
      </div>
      <div class="rec_jieyu">
        升級後樓盤到期日：
        {{ starUpgradeObj.targetDate }}
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="goonStep()"
        >
          確 認
        </el-button>
      </div>
    </el-dialog>

    <!-- 尚未注册 -->
    <el-dialog
      :visible.sync="showLogin"
      width="30%"
      class="showTopLogin"
      :before-close="closeLogin"
    >
      <div class="title">
        <i class="el-icon-warning-outline" /><span>你登入IBS的電郵，尚未註冊PMS賬戶</span>
      </div>
      <span class="content">請與你的主管聯絡</span>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="closeLogin"
        >確 定</el-button>
      </span>
    </el-dialog>

    <!-- 刊登分數 -->
    <el-dialog
      :show-close="true"
      :before-close="quitSub"
      :close-on-click-modal="false"
      title="曝光等級提示"
      :visible.sync="postScoreVisible"
      width="35%"
      class="showpostScore"
    >
      <div>在相同放盤方式下，你的樓盤曝光等級：</div>
      <div class="starbox">
        <span
          v-for="index in postScore.scoreStar"
          :key="index"
          class="starimg"
        >
          <img
            src="../../../assets/scorestar.svg"
            alt="##"
          >
        </span>
        <span
          v-for="index in 4 - postScore.scoreStar"
          :key="index + 'score'"
          class="starimg"
        >
          <img
            src="../../../assets/scorestar_gray.svg"
            alt="##"
          >
        </span>
        <span class="redTit">&nbsp;&nbsp;({{ postScore.scoreAdRank }})</span>
      </div>
      <div v-if="postScore.score !== '250'">
        <div v-if="postScore.scoreReason.length">
          你可以嘗試以下內容提升等級
        </div>
        <div
          v-for="(item, index) in postScore.scoreReason"
          :key="index"
          class="pointF"
        >
          <div class="orderpoint" />
          &nbsp;&nbsp;&nbsp;{{ item }}
        </div>
      </div>
      <div class="titVr">
        如想獲得最高等級，必須加入VR，如有興趣拍攝VR，請與我們的營業代表聯絡
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="postScore.score !== '250'"
          type="primary"
          class="btrad"
          @click="quitSub"
        >好的，去調整</el-button>
        <el-button
          type="danger"
          class="btrad"
          @click="goonSub"
        >{{ mode == 'edit' ? '確認修改' : '繼續放盤' }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="素材编辑"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="editImgDialogVisible"
      class="edit_image_dialog"
      width="1000px"
      height:="1000px"
      :close-on-click-modal="false"
    >
      <div id="tui-image-editor" />
      <span
        slot="footer"
        class="dialog-footer"
        style="margin-top:-20px"
      >
        <span class="editImgcla">建議編輯範圍少於三分之一。超出範圍有可能令客人無法清晰瀏覽。 </span>
        <el-button @click="editImgDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="uploadEditImg(selectedImage[0])"
        >完 成</el-button>
      </span>
    </el-dialog>
    <!-- 修改楼盘验证提示 -->
    <!-- <el-dialog title="樓盤驗證失效提示" :before-close="conVerify" :visible.sync="verifyVisible" width="35%" class="showpostScore" :close-on-click-modal="false">
            <div>因為你修改過以下任何一個資料，樓盤驗證會失效，我們需要重新審核</div>
            <div class="pointF" v-for="(item,index) in verifyExpire"  :key="index"><div class="orderpoint"></div>&nbsp;&nbsp;&nbsp;{{item}}</div>
            <div class="titVr">請問需要重新提交樓盤驗證嗎？</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="conVerify">否</el-button>
                 <el-button type="primary" @click="goonVeify">是</el-button>
            </span>
        </el-dialog> -->
  </div>
</template>
<script>
import postCore from './postCore';
export default postCore;
</script>
<style lang="less" scoped>
@import './index.less';
</style>
